<form [formGroup]="orderFormGroup" id="payment-form" style="padding:0px;" class="col-xs-12" novalidate>
    <div class="order-promotion-block">
        <div class="row-sameheight-block">
            <div class="column-equal grayborder-1">
                <div class="col-xs-12 col-sm-3 padding-left-0 form-group floating-input">
                    <select #country id="country" class="form-control" formControlName="countryId"
                        (change)="selectedCountry()">
                        <option value="" disabled="true">{{'order.Select Store' |translate |translateKey}}</option>
                        <option *ngFor="let country of stores | orderBy:'name'" [value]="country.countryId">
                            {{country.name}}</option>
                    </select>
                    <div class="alert-msg"
                        *ngIf="!orderFormGroup.controls['countryId'].valid && (orderFormGroup.controls['countryId'].touched || isSubmitted)">
                        {{'order.Country Details are mandatory' |translate |translateKey}}</div>
                </div>
                <div *ngIf="hasParticipatingCountries" class="col-xs-12 col-sm-3 padding-left-0 form-group floating-input">
                    <select #country id="participatingCountry" class="form-control" formControlName="participatingCountry"
                        (change)="showWarningPopup($event);" (ngModel)="associatedCountry">
                        <option value="" disabled="true">{{'order.Participating Country' |translate |translateKey}}</option>
                        <option *ngFor="let country of associatedCountries | orderBy:'name'" [value]="country.countryId">
                            {{country.name}}</option>
                    </select>
                </div>
                <div class="col-xs-12 col-sm-3 padding-left-0 floating-input">
                    <select class="form-control" formControlName="language" (change)="onChangeLanguage()">
                        <option value="" disabled="true">{{'order.Language' |translate |translateKey}}</option>
                        <option *ngFor="let language of storeLanguages" [value]="language.cultureName">
                            {{language.displayText}}</option>
                    </select>
                </div>
                <div class="col-xs-12 col-sm-3 padding-left-0 clearboth">
                    <div class="quick-add-block position-relative">
                        <div class="overlay-label">
                            {{'order.Quick Add by Item# or Name' |translate |translateKey}}</div>
                        <input formControlName="itemSearch" ngui-auto-complete display-property-name="itemSearch"
                            (valueChanged)="onItemSelect(false)" [source]="observableSource.bind(this)" [max-num-list]="7"
                            [tab-to-select]="false" [select-on-blur]="false" [min-chars]="2"
                            [re-focus-after-select]="false" [list-formatter]="autocompleListFormatter"
                            class="form-control" id="seachItemElement" #seachItemElement
                            placeholder="Suggestions appear after 2 letter input" [attr.disabled]="appConfig && appConfig.displayOnlyEnrollmentItem ?'':null"/>
                    </div>
                </div>
                <div *ngIf="(featuredPacks && featuredPacks.length > 0) || (enrollmentKits && enrollmentKits.length > 0)" class="col-xs-12 col-sm-3 padding-left-0 form-group floating-input">
                    <select #fboEligibleProduct id="fboEligibleProducts" class="form-control" formControlName="fboEligibleProducts"
                        (change)="onItemSelect(true)" (ngModel)="selectedFboEligibleProduct">
                        <option value="" disabled="true">{{'order.FBO Eligible Products' |translate |translateKey}}</option>
                        <option disabled *ngIf="featuredPacks && featuredPacks.length > 0">──────────</option>
                        <option disabled *ngIf="featuredPacks && featuredPacks.length > 0">{{'order.Feaured Packs' |translate |translateKey}}</option>
                        <!--<option *ngFor="let featurepack of featuredPacks | orderBy:'name'" [value]="featurepack.id">-->
                        <option *ngFor="let featurepack of featuredPacks|slice: 0:1" [value]="featurepack?.id">
                            {{featurepack?.name}}  <span *ngIf="featurepack && featurepack.display.fboEligible && featurepack.productTypeMasterId !== variableProduct">----- {{'order.2CC Eligible' |translate |translateKey}}</span></option>
                        <option disabled>──────────</option>
                        <option disabled *ngIf="enrollmentKits && enrollmentKits.length > 0">{{'order.Enrollment Kits' |translate |translateKey}}</option>
                        <option *ngFor="let enrollmentKit of enrollmentKits | orderBy:'name'" [value]="enrollmentKit.id">
                            {{enrollmentKit.name}}  <span *ngIf="enrollmentKit && enrollmentKit.display.fboEligible && enrollmentKit.productTypeMasterId !== variableProduct">---- {{'order.2CC Eligible' |translate |translateKey}}</span></option>
                    </select>
                </div>
                <div *ngIf="showOptions" class="col-xs-12 col-sm-3 padding-left-0 form-group floating-input">
                    <select #productOptions id="productOptions" class="form-control" formControlName="productOptions"
                        (change)="productOptionSelected()" (ngModel)="selectedProductOption">
                        <option value="" disabled="true">{{'order.Select from product options' |translate |translateKey}}</option>
                        <option *ngFor="let option of optionValues | orderBy:'name'" [value]="option.id">
                            {{option.name}}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="mb-20">
            <span class="fboEligibility" *ngIf="appConfig && !appConfig.displayOnlyEnrollmentItem">{{'order.To enroll as an FBO, either 2CC Eligible product should be added or Total CC value should be minimum 2' |translate |translateKey}}</span>
            <span class="fboEligibility" *ngIf="appConfig && appConfig.displayOnlyEnrollmentItem">
                {{'order.Products cannot be added for the selected country to enroll as an FBO. Please select from FBO Eligible products dropdown' |translate |translateKey}}
            </span>
        </div>
        <div *ngIf="itemCount">{{itemCount}} Item(s)</div>
        <div>
             <!-- order grid  -->
            <div class="table-responsive mb-20 quanity-increment-table">
                <table class="table table-striped custab">
                    <thead>
                        <tr>
                            <th>
                                <strong>{{'customer-service.Item #' |translate}}
                                </strong>
                            </th>
                            <th class="">
                                <strong>{{'customer-service.Product Description' |translate |translateKey}}
                                </strong>
                            </th>
                            <th class="">
                                <strong>{{'customer-service.Product Image' |translate}}
                                </strong>
                            </th>
                            <th class="">
                                <strong>{{'customer-service.Unit Price' |translate}}
                                </strong>
                            </th>
                            <th class="w-250 text-center">
                                <strong>{{'customer-service.Quantity' |translate |translateKey}}
                                </strong>
                            </th>
                            <th class="text-center">
                                <strong>{{'customer-service.Total CC' |translate |translateKey}}

                                </strong>
                            </th>
                            <th class="text-center">
                                <strong>{{'customer-service.Total Price' |translate |translateKey}}
                                </strong>
                            </th>
                            <th class="text-center">
                                <strong>{{'customer-service.Remove' |translate |translateKey}}</strong>
                            </th>

                        </tr>
                    </thead>
                    <tbody formArrayName="items" *ngIf="orderFormGroup.get('items').value.length">
                        <tr *ngFor="let item of getFormControls(); let i = index;" class="items height-78"
                            [formGroupName]="i">
                             <!-- Item #  -->
                            <td>
                                <div *ngIf="orderFormGroup.controls['items'].controls[i].controls['productItem'].value.orderPromotionTrackings && orderFormGroup.controls['items'].controls[i].controls['productItem'].value.orderPromotionTrackings.length > 0 " class="free-ribbon" >{{appConfig.freeProductNameChange ? ('customer-service.Packaging Bag' |translate |translateKey) : 'customer-service.Free' |translate |translateKey }}</div>
                                <span *ngIf ="!orderFormGroup.controls['items'].controls[i].controls['isDepositFeeProduct'].value">
                                    {{orderFormGroup.controls['items'].controls[i].controls['productNumber'].value}}
                                </span>
                            </td>
                            <input type="hidden" formControlName="itemNumber">
                            <input type="hidden" formControlName="productId">
                            <input type="hidden" formControlName="productItem">
                            <td>{{orderFormGroup.controls['items'].controls[i].controls['productName'].value}}
                            </td>
                             <!-- Unit Price  -->
                            <td class=""><img width="60px" role="img" err-img
                                    src="{{orderFormGroup.controls['items'].controls[i].controls['productImage'].value}}"
                                    alt="product image" /></td>
                            <td class="">
                                <label *ngIf="orderFormGroup.controls['items'].controls[i].controls['productItem']&&
                                    orderFormGroup.controls['items'].controls[i].controls['productItem'].value &&
                                    orderFormGroup.controls['items'].controls[i].controls['quantity'] &&
                                    orderFormGroup.controls['items'].controls[i].controls['quantity'].value">
                                    <span *ngIf="(displayPriceConfig && displayPriceConfig.displayApplicablePrice)">
                                        {{orderFormGroup.controls['items'].controls[i].controls['productItem'].value.applicablePrice
                                            | currencyFormat:storeInfo}}
                                    </span>
                                    <span *ngIf="(displayPriceConfig && displayPriceConfig.displayComputedTaxInclusivePrice)">
                                        {{orderFormGroup.controls['items'].controls[i].controls['productItem'].value.computedTaxInclusivePrice
                                            | currencyFormat:storeInfo}}
                                    </span>
                                    <span *ngIf="(displayPriceConfig && displayPriceConfig.displayCatalogPrice)">
                                        {{orderFormGroup.controls['items'].controls[i].controls['productItem'].value.catalogPrice
                                            | currencyFormat:storeInfo}}
                                    </span>
                                </label>
                                <app-price-popover
                                    *ngIf="memberDiscountPercentage && displayPriceConfig
                                        && orderFormGroup.controls['items'].controls[i].controls['productItem']&&
                                        orderFormGroup.controls['items'].controls[i].controls['productItem'].value && !(orderFormGroup.controls['items'].controls[i].controls['productItem'].value.applicablePrice === orderFormGroup.controls['items'].controls[i].controls['productItem'].value.retailPrice)"
                                    tabindex="0" [memberInfo]="memberInfo" [storeInfo]="storeInfo"
                                    [memberDiscountPercentage]="memberDiscountPercentage"
                                    [product]="orderFormGroup.controls['items'].controls[i].controls['productItem'].value"
                                    [displayPriceConfig]="displayPriceConfig"
                                    [memberTitleId]="getMemberTitleId()"></app-price-popover>
                                <label class="srp" *ngIf="orderFormGroup.controls['items'].controls[i].controls['productItem']&&
                                                orderFormGroup.controls['items'].controls[i].controls['productItem'].value &&
                                                orderFormGroup.controls['items'].controls[i].controls['quantity'] &&
                                                orderFormGroup.controls['items'].controls[i].controls['quantity'].value
                                                && !(orderFormGroup.controls['items'].controls[i].controls['productItem'].value.applicablePrice === orderFormGroup.controls['items'].controls[i].controls['productItem'].value.retailPrice)
                                                && !displayPriceConfig.displayBaseRetailPrice">
                                        {{(orderFormGroup.controls['items'].controls[i].controls['productItem'].value.retailPrice)
                                        | currencyFormat:storeInfo}}
                                    </label>
                                <label class="srp" *ngIf="orderFormGroup.controls['items'].controls[i].controls['productItem']&&
                                            orderFormGroup.controls['items'].controls[i].controls['productItem'].value &&
                                            orderFormGroup.controls['items'].controls[i].controls['quantity'] &&
                                            orderFormGroup.controls['items'].controls[i].controls['quantity'].value
                                            && !(orderFormGroup.controls['items'].controls[i].controls['productItem'].value.applicablePrice === orderFormGroup.controls['items'].controls[i].controls['productItem'].value.retailPrice)
                                            && displayPriceConfig.displayBaseRetailPrice">
                                    {{(orderFormGroup.controls['items'].controls[i].controls['productItem'].value.baseRetailPrice)
                                    | currencyFormat:storeInfo}}
                                </label>
                            </td>
                             <!-- Quantity Block  -->
                            <td class="quanity-block">
                                <div class="col-md-2 no-padding no-border" *ngIf ="!orderFormGroup.controls['items'].controls[i].controls['isDepositFeeProduct'].value">
                                    <span
                                        [ngClass]="{'disableDecrement':(orderFormGroup.controls['items'].controls[i].controls['quantity'].value==1 ||
                                        !orderFormGroup.controls['items'].controls[i].controls['quantity'].value ||
                                        orderFormGroup.controls['items'].controls[i].controls['disableDecrement'].value ||
                                        (appConfig && appConfig.displayOnlyEnrollmentItem))}"
                                        class="fa fa-minus qtyminus" (mousedown)="disableSubmitButton()"
                                        (click)="decrementQuantity(i)"
                                        (keyup.enter)="moveToItemLevelSearchBlock($event)" >
                                        <label class="visuallyhidden">{{'order.decrement Quantity button
                                                    |translate |translateKey'}}
                                        </label>
                                    </span>
                                </div>
                                <div class="col-md-6 no-padding" *ngIf ="!orderFormGroup.controls['items'].controls[i].controls['isDepositFeeProduct'].value">
                                    <input role="textbox" id="quantity-{{i}}" aria-label="quantity" min="1"
                                        (blur)="updateQuantity($event,i)" class="quanity form-control quantity-{{i}}"
                                        maxlength="3" formControlName="quantity" (keypress)="allowOnlyNumbers($event)"
                                        (onfocusout)="updateQuantity($event,i)" (keydown)="quantityChange($event, i)"
                                        (keyup)="quantityChange($event, i)" type="text" OnlyNumber="true"
                                        (keyup.enter)="moveToItemLevelSearchBlock($event)" [attr.disabled]="(appConfig && appConfig.displayOnlyEnrollmentItem) ||
                                        orderFormGroup.controls['items'].controls[i].controls['disableIncrement'].value ? true:null">
                                    <div aria-live="assertive" class="alert-msg"
                                        *ngIf="!orderFormGroup.controls['items'].controls[i].controls['quantity'].valid&&orderFormGroup.controls['items'].controls[i].controls['quantity'].hasError('required')&& (orderFormGroup.controls['items'].controls[i].controls['quantity'].touched || isSubmitted)">
                                        {{'order.Enter Quantity' | translate | translateKey}}!
                                    </div>
                                </div>
                                <div class="col-md-2 no-padding" *ngIf ="!orderFormGroup.controls['items'].controls[i].controls['isDepositFeeProduct'].value">
                                    <span class="fa fa-plus qtyplus" (mousedown)="disableSubmitButton()"
                                        (click)="incrementQuantity(i)"
                                        [ngClass]="{'disableDecrement':(orderFormGroup.controls['items'].controls[i].controls['disableIncrement'].value ||
                                        orderFormGroup.controls['items'].controls[i].controls['quantity'].value == 999 ||
                                        (appConfig && appConfig.displayOnlyEnrollmentItem)) }"
                                        (keyup.enter)="moveToItemLevelSearchBlock($event)">
                                        <label class="visuallyhidden">{{'order.increment Quantity button'
                                                    |translate |translateKey}}
                                        </label>
                                    </span>
                                </div>
                            </td>
                             <!-- Total CC  -->
                            <td class="text-center">
                                <label class=""
                                    *ngIf="orderFormGroup.controls['items'].controls[i].controls['productItem']&&
                                                    orderFormGroup.controls['items'].controls[i].controls['productItem'].value &&
                                                    orderFormGroup.controls['items'].controls[i].controls['quantity'] &&
                                                    orderFormGroup.controls['items'].controls[i].controls['quantity'].value &&
                                                    !orderFormGroup.controls['items'].controls[i].controls['isDepositFeeProduct'].value">
                                    {{(orderFormGroup.controls['items'].controls[i].controls['productItem'].value.commissionableVolume
                                            * orderFormGroup.controls['items'].controls[i].controls['quantity'].value)
                                            | ccFormat:storeInfo:false}}
                                </label>
                            </td>
                             <!-- Total Price  -->
                            <td class="text-center">
                                <label *ngIf="orderFormGroup.controls['items'].controls[i].controls['productItem'] &&
                                    orderFormGroup.controls['items'].controls[i].controls['productItem'].value &&
                                    orderFormGroup.controls['items'].controls[i].controls['quantity'] &&
                                    orderFormGroup.controls['items'].controls[i].controls['quantity'].value">
                                    {{ getItemTotalSum(orderFormGroup.controls['items'].controls[i].controls['productItem'].value)  | currencyFormat:storeInfo }}
                                </label>
                            </td>
                             <!-- Remove Button  -->
                            <td class="options text-center">
                                <button type="button" (click)="deleteItem(i)" [ngClass]="{'disableDecrement':(orderFormGroup.controls['items'].controls[i].controls['disableDelete'].value
                                    || (appConfig && appConfig.displayOnlyEnrollmentItem))}"
                                    *ngIf ="!orderFormGroup.controls['items'].controls[i].controls['isDepositFeeProduct'].value"
                                    class="btn-link item-trash-link no-padding" tabindex="-1">
                                    <i class="fa fa-trash"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                    <tbody class="border-top-0">
                        <tr>
                            <td class="height-78">
                                <input #itemLevelSearch id="itemLevelSearch" role="textbox" tabindex="0"
                                    class="itemLevelSearch"
                                    placeholder="{{'customer-service.Item #' | translate |translateKey}}"
                                    formControlName="itemLevelSearch" type="text" (blur)="itemLevelSearchEvent($event)" [attr.disabled]="appConfig && appConfig.displayOnlyEnrollmentItem ? true:null">
                            </td>
                            <td class="outline-none" tabindex="0"></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="row-sameheight-block mtb-20">
         <div class="flex-left-60 mtb-20 border-around policy-block" *ngIf="isFBOEnrollmentEligible">
            <span class="my-3">{{'order.Congratulations FBO' | translate }}</span>
            <div id="agreementBlock" *ngIf="agreementDocuments" class="agreement-block mtb-20">
                <div class="py-1 mt-10" *ngFor="let fboDocument of agreementDocuments;let i=index;">
                    <label tabindex="0" class="check-lbl form-check-box">
                        <input role="checkbox" type="checkbox" aria-label="" class="check-box" name="" id=""
                            (change)="checkFboDocumentSelection(i);" [checked]="fboDocument?.isSelected">
                        <span class="label-text"></span>
                        <span class="form-check-text"> {{'customer-service.I agree to' | translate | translateKey}}
                            <span class="" *ngIf="fboDocument?.documentUrl">
                                <a class="learn-more align-top link--light d-inline-block" target="_blank"
                                    [href]="fboDocument?.documentUrl">{{fboDocument?.displayName}}</a>
                            </span>
                            <span *ngIf="!(fboDocument?.documentUrl)">{{fboDocument?.displayName}}</span>
                        </span>
                    </label>
                </div>
            </div>
        </div>

        <!-- Order Summary Section starts-->
         <div class="column-equal mt-20 flex-right-28-no-border">
            <div class="table-responsive">
                <table class="table table-striped table-bordered custab">
                    <thead>
                        <tr>
                            <th>{{'customer-service.Order Summary' |translate |translateKey}}</th>
                            <th>{{'customer-service.Amount' |translate |translateKey}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{{'customer-service.Sub Total' |translate |translateKey}}</td>
                            <td class="text-right">{{calculateItemsSubTotal(storeInfo) | currencyFormat:storeInfo}}
                            </td>
                        </tr>
                        <tr>
                            <td *ngIf="orderFormGroup.value.deliveryPreference===deliveryPreference.DELIVERY">
                                {{'customer-service.Shipping' |translate |translateKey}}</td>
                            <td *ngIf="orderFormGroup.value.deliveryPreference===deliveryPreference.PICKUP || orderFormGroup.value.deliveryPreference===deliveryPreference.DROPSHIP">
                                {{'customer-service.Handling' |translate |translateKey}}</td>
                            <td class="text-right">{{getShippingCostForOrderSummary() | currencyFormat:storeInfo}}
                            </td>
                        </tr>
                        <tr *ngIf="appConfig && appConfig.displayTax">
                            <td>{{'customer-service.Taxes' |translate |translateKey}}</td>
                            <td class="text-right" >{{(taxableAmount ? retailDeliveryFee ? taxableAmount - retailDeliveryFee : taxableAmount:0) | currencyFormat:storeInfo}}</td>
                        </tr>
                        <ng-container
                            *ngIf="storeInfo?.taxInclusive && (appConfig?.displayVat || (!appConfig.enableVatItemizationForNonVat && ((bonusInformation && bonusInformation.vatId)|| checkoutConfig?.vatInPersonalInfo && personalInformation && personalInformation.vatId)) || (appConfig.enableVatItemizationForNonVat)) && orderTaxResponse?.taxMetaData?.orderTaxCharges && countryTaxInclusive && !appConfig?.displayTaxInclusivePrice">
                            <tr
                                *ngFor="let item of orderTaxResponse?.taxMetaData?.orderTaxCharges | orderBy:'taxRate' | groupBy:['taxChargeType','taxRate'];let i=index;trackBy:trackByItem">
                                <td *ngIf="item.value[0].taxRate > 0">{{'customer-service.VAT' | translate | translateKey}} <span *ngIf="appConfig.displayTaxCode">({{item.value[0].taxChargeType}}){{item.value[0].taxRate}}%</span>
                                    <span *ngIf="!appConfig.displayTaxCode">({{item.value[0].taxRate}}%)</span></td>
                                <td class="text-right" *ngIf="item.value[0].taxRate > 0">{{ getItemVolumeSum(item.value) | currencyFormat:storeInfo}}
                                </td>
                            </tr>
                        </ng-container>
                        <ng-container
                            *ngIf="storeInfo?.taxInclusive && (appConfig?.displayCustomTaxName) && orderTaxResponse?.taxMetaData?.orderTaxCharges && countryTaxInclusive">
                            <tr
                                *ngFor="let item of orderTaxResponse?.taxMetaData?.orderTaxCharges | orderBy:'taxRate' | groupBy:['taxChargeType','taxRate'];let i=index;trackBy:trackByItem">
                                <td *ngIf ="item.value[0].taxChargeType === taxType.NOR && item.value[0].taxRate > 0">{{'customer-service.GST' | translate}}</td>
                                <td class="text-right" *ngIf ="item.value[0].taxChargeType === taxType.NOR && item.value[0].taxRate > 0">{{ getItemVolumeSum(item.value) | currencyFormat:storeInfo}}
                                </td>
                            </tr>
                        </ng-container>

                        <tr *ngIf="appConfig && appConfig.displayGST">
                            <td>{{'customer-service.GST/HST' |translate |translateKey}}</td>
                            <td class="text-right">{{(gstTax ? gstTax:0) | currencyFormat:storeInfo}}
                            </td>
                        </tr>
                        <tr *ngIf="appConfig && appConfig.displayPST">
                            <td>{{'customer-service.PST/QST' |translate |translateKey}}</td>
                            <td class="text-right">{{(pstTax ? pstTax:0) | currencyFormat:storeInfo}}
                            </td>
                        </tr>
                        <tr>
                            <td>{{'customer-service.Fees' |translate |translateKey}}</td>
                            <td class="text-right">{{(importFeeValue?importFeeValue:0) | currencyFormat:storeInfo}}
                            </td>
                        </tr>
                        <tr *ngIf="retailDeliveryFee">
                            <td>{{'customer-service.Retail Delivery Fee' |translate |translateKey}}</td>
                            <td class="text-right">{{(retailDeliveryFee ? retailDeliveryFee : 0) | currencyFormat:storeInfo}}</td>
                        </tr>
                        <tr class="bold" *ngIf="appConfig?.displayTaxInclusivePrice">
                            <td>{{'customer-service.Total CC' |translate |translateKey}}</td>
                            <td class="text-right"><span *ngIf="storeInfo">{{totalCommissionableVolume
                                | ccFormat:storeInfo:false}}</span></td>
                        </tr>
                        <tr class="bold">
                            <td>{{'customer-service.Total' |translate |translateKey}}</td>
                            <td class="text-right">{{ calculateOrderTotal() | currencyFormat:storeInfo}}</td>
                        </tr>
                        <tr class="bold" *ngIf="!appConfig?.displayTaxInclusivePrice">
                            <td>{{'customer-service.Total CC' |translate |translateKey}}</td>
                            <td class="text-right"><span *ngIf="storeInfo">{{totalCommissionableVolume
                                | ccFormat:storeInfo:false}}</span></td>
                        </tr>
                        <ng-container
                            *ngIf="storeInfo?.taxInclusive && (appConfig?.displayVat || (!appConfig.enableVatItemizationForNonVat && ((bonusInformation && bonusInformation.vatId)|| checkoutConfig?.vatInPersonalInfo && personalInformation && personalInformation.vatId)) || (appConfig.enableVatItemizationForNonVat)) && orderTaxResponse?.taxMetaData?.orderTaxCharges && countryTaxInclusive && appConfig?.displayTaxInclusivePrice">
                            <tr
                                *ngFor="let item of orderTaxResponse?.taxMetaData?.orderTaxCharges | orderBy:'taxRate' | groupBy:['taxChargeType','taxRate'];let i=index;trackBy:trackByItem">
                                <td *ngIf="item.value[0].taxRate > 0">{{'customer-service.Includes' | translate | translateKey}} <span *ngIf="appConfig?.displayTaxCode">{{item.value[0].taxRate}} % {{'customer-service.VAT' | translate | translateKey}}</span>
                                    <span *ngIf="!appConfig?.displayTaxCode">({{item.value[0].taxRate}}%)</span></td>
                                <td class="text-right" *ngIf="item.value[0].taxRate > 0">{{ getItemVolumeSum(item.value) | currencyFormat:storeInfo}}
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>
        </div>
        <!-- Order Summary Section ends-->

    </div>


    <div class="row-sameheight-block mtb-20">
        <!-- Personal Info Section Starts-->
        <div class="flex-left-40 personal-info-section" *ngIf="storeInfo && personalInfoSchemaUrl && isFBOEnrollmentEligible">
            <div class="row margin-5">
                <div class="col-xs-12 mb-5"><span
                        class="color-blue">{{'order.Personal Information' | translate | translateKey | uppercase}}</span>
                </div>
            </div>
            <div class="my-6">
                <app-personal-info-form (personalInfoSubmit)="getPersonalInfoFrom($event)" [personalInfoSchemaUrl]="personalInfoSchemaUrl"
                        [preloadPersonalInformation]="personalInformation" (personalInfoSubmitOnInputChange)="getPersonalInfoOnInputChange($event)" [storeConfig]="storeInfo">
                </app-personal-info-form>
            </div>
        </div>

        <!-- Personal Info section Ends -->
    </div>

    <div class="row-sameheight-block mtb-20">
        <!-- Business Information starts-->
        <div class="flex-left-40 bonus-info-section" *ngIf="storeInfo && storeSettings && storeSettings.showBusinessInfoSection && isFBOEnrollmentEligible">
            <div class="row margin-5">
                <div class="col-xs-12 mb-5"><span
                        class="color-blue">{{'order.Business Information' | translate | translateKey | uppercase}}</span>
                </div>
            </div>
            <div class="my-6" >
                <app-business-info (businessInfoSubmit)="getBusinessInfo($event)" [businessSchemeUrl]="bonusInfoSchemaUrl"
                        [preloadBusinessInformation]="businessInformation" (businessInfoSubmitOnInputChange)="getBusinessInfoOnInputChange($event)">
                </app-business-info>

            </div>
	</div>
        <!--Business Information ENDS-->
        <!-- Bonus Info Section Starts-->
        <div class="flex-left-40 bonus-info-section" *ngIf="storeInfo && storeSettings && storeSettings.showBonusInfoSection && isFBOEnrollmentEligible">
            <div class="row margin-5">

                <div class="col-xs-12 mb-5"><span
                        class="color-blue">{{'order.Bonus Information' | translate | translateKey | uppercase}}</span>
                    </div>
            </div>
            <div class="my-6" *ngIf="!storeSettings.bonusInfoPaymentOptions">
                <div>
                    <span *ngIf="isBeneluxCountry">
                        <h2>{{'Deposit Forever bonus into a personal bank account.'}}</h2>
                    </span>
                </div>
                <app-bonus-info-form (bonusInfoSubmit)="getBonusInfo($event)" [bonusInfoSchemaUrl]="bonusInfoSchemaUrl"
                        [preloadBonusInformation]="bonusInformation" (bonusInfoSubmitOnInputChange)="getBonusInfoOnInputChange($event)">
                    </app-bonus-info-form>
                    <div *ngIf="isBeneluxCountry" style="padding: 15px;">
                    <div class="col-12 form-check px-0 my-2" *ngFor="let agreement of bonusInfoAgreements;let i = index;">
                        <label tabindex="0" class="check-lbl form-check-box font-16">
                        <input role="checkbox" type="checkbox" aria-label="" (change)="selectedAgreements(agreement)" [disabled]="disableBonusInfoChecks"
                          class="check-box" name="" value="true" id="" [checked]="agreement.isSelected">
                        <span class="label-text"></span>
                          <span class="form-check-text">{{'I have read and agreed to the' }}
                            <span class="" *ngIf="!(agreement?.documentUrl)">{{agreement?.displayName}}</span>
                            <span (click)="$event?.stopPropagation();" *ngIf="agreement?.documentUrl">
                             <a class="link--light align-top d-inline-block" target="_blank" [href]="agreement?.documentUrl">{{agreement?.displayName}}</a>
                            </span>
                          </span>
                        </label>
                    </div>
                    <div *ngIf="displayIBANAckError">
                        <span class="text-red">
                        {{ 'You must agree to terms and conditions before proceeding'}}
                    </span>
                </div>
                    </div>
            </div>
        <div *ngIf="storeSettings.bonusInfoPaymentOptions">
            <div class="row px-0 mb-2 bonusInfo" >
                <div class="form-check pl-0">
                    <label class="form-check-box benelux d-flex-rtl" tabindex="-1">
                        <input type="radio" #directDeposit name="directDeposit"
                            [checked]="bonusPaymentOptionType === bonusPaymentOption.BANK_DETAILS"
                            (click)="selectBonusPaymentType(bonusPaymentOption.BANK_DETAILS)">
                        <span class="label-text"></span>
                        <span tabindex="0" (keyup.control.space)="directDeposit.click()" role="radio"
                            (keyup.enter)="directDeposit.click()" class="form-check-text">{{"checkout.payment Option: Direct
                            Deposit" | translate | translateKey}}
                        </span>
                    </label>
                </div>
            </div>
            <div class="pl-4 bonusInfo" *ngIf="bonusPaymentOptionType === bonusPaymentOption.BANK_DETAILS">
                <div class="mb-3">
                    <span class="bonusDetails">{{"checkout.Deposit my Forever bonus into a personal bank account." | translate }}
                    </span>
                    <span>{{"checkout.Note: Direct Deposit is currently available for Australian Bank Account only" | translate }}
                    </span>
                </div>
                <app-bonus-info-form (bonusInfoSubmit)="getBonusInfo($event)" [bonusInfoSchemaUrl]="bonusInfoSchemaUrl"
                    [preloadBonusInformation]="bonusInformation" (bonusInfoSubmitOnInputChange)="getBonusInfoOnInputChange($event)">
                </app-bonus-info-form>
            </div>
            <div class="row px-0 mt-2 bonusInfo">
                <div class="form-check pl-0">
                    <label class="form-check-box " tabindex="-1">
                        <input type="radio" #decideLater name="decideLater"
                            [checked]="bonusPaymentOptionType === bonusPaymentOption.DECIDE_LATER"
                            (click)="selectBonusPaymentType(bonusPaymentOption.DECIDE_LATER)">
                        <span class="label-text"></span>
                        <span tabindex="0" (keyup.control.space)="decideLater.click()" role="radio"
                            (keyup.enter)="decideLater.click()" class="form-check-text">{{"checkout.payment Option: Decide
                            Later" | translate}}
                        </span>
                    </label>
                </div>
            </div>
            <div class="pl-4 mt-1 bonusInfo" *ngIf="bonusPaymentOptionType === bonusPaymentOption.DECIDE_LATER">
                <span>{{"checkout.Not 100% sure how you would like to recieve your Forever Bonus ? You can decide later on the My Preferences page within the distributor site in  the meantime, your bonus will arrive in the form of a check" | translate }} </span>
             </div>
             <div class="alert-msg bonusInfo" *ngIf="isSubmitted && !(bonusInformation || bonusPaymentOptionType === bonusPaymentOption.DECIDE_LATER)">
                <span>{{"checkout.please enter Business Information or decideLater option"| translate }} </span>
             </div>
        </div>
        </div>
        <!-- Bonus Info section Ends -->
    </div>


    <div class="row-sameheight-block mtb-20">
        <!-- Mailing Address Section Starts -->
         <div class="row-sameheight-block mtb-20" *ngIf="isFBOEnrollmentEligible">
            <div class="flex-left-40 mailing-address-block {{checkoutConfig?.mailingAddressHeight}}">
                <div class="row margin-5">
                    <div class="col-xs-12 mb-5"><span
                            class="color-blue">{{'order.Mailing Address' | translate | translateKey | uppercase}}</span>
                    </div>
                </div>
                <div class="my-20" *ngIf="storeInfo && displayMailingAddressForm && mailingSchemaUrl">
                    <app-address-new (addressSubmit)="getMailingAddressInfo($event)" [schemaUrl]="mailingSchemaUrl"
                        [schemaClass]="'mailing-address-block'" [skipAddressVerification]="skipAddressVerification"
                        (addressSubmitOnInputChange)="getAddressOnInputChange($event)" [countryCode]="participatingCountry? participatingCountry.isocodeThree : countryCode"
                        [preloadAddress]="mailingAddress || liveFormAddress" [isInputChangeRequired]="true"
                        (notifyInvalidAddress)="notifyInvalidAddress($event)" [isEnableVerifyButton]="true"
                        (addressHidden)="showMailingAddress = $event" [participatingCountry]="participatingCountry">
                    </app-address-new>
                </div>
                <div class="verified-address col-xs-6"
                    [class.align-verified-address]="!(storeInfo && displayMailingAddressForm && mailingSchemaUrl) || !showMailingAddress"
                    *ngIf="mailingAddress && mailingAddress !== null">
                    <span class="verified" *ngIf="mailingAddress?.addressVerified ||checkoutConfig.verifyMailingWithButton">
                        <i class="fa fa-check verified-symbol" aria-hidden="true">
                            {{'customer-service.Verified' |translate |translateKey}}</i>
                    </span>
                    <span class="notverified"
                        *ngIf="!mailingAddress?.addressVerified && !checkoutConfig.verifyMailingWithButton">
                        <i class="fa fa-times verified-symbol" aria-hidden="true">
                            {{'customer-service.Not Verified' |translate |translateKey}}</i>
                    </span>

                </div>
                <div class="col-xs-12" *ngIf="storeInfo && displayMailingAddressForm && mailingSchemaUrl
                && checkoutConfig && checkoutConfig.displaySearchAddressSection && !checkoutConfig.hideSearchAddressLink">
                    <span>{{'checkout.Don’t see a match?' | translate | translateKey}}</span>
                    <span (click)="enableAddressFields('mailing-address-block')"><a class="link--light"
                            tabindex="0">{{'checkout.Click here' | translate | translateKey}}</a></span>
                    <span>{{'checkout.to enter address' | translate | translateKey}}</span>
                </div>
            </div>
        </div>
        <!-- Mailing Address Section Ends -->
    </div>

    <!-- Sponosor Info Section Starts-->
    <div class="row-sameheight-block" *ngIf="storeInfo && orderFormGroup.value.orderType === orderTypeFBO && isFBOEnrollmentEligible">
        <div class="flex-left-40 personal-info-section" *ngIf="storeInfo">
            <div class="row margin-5">
                <div class="col-xs-12 mb-5"><span
                        class="color-blue">{{'order.Choose Referring Fbo' | translate | translateKey | uppercase}}</span>
                </div>
            </div>
            <div class="my-6">
                <app-sponsor-search [storeInfo]="storeInfo" [selectedOrderType]="orderTypeFBO"
                    [selectedSponsor]="orderSession && orderSession.sponsorInformation ? orderSession.sponsorInformation : sponsorInformation"
                    [rebindSponsorOptions]="rebindSponsorData" (selectedSponsorInfo)="getSelectedSponserInfo($event)"
                    (rebindSponsor)="rebindSponsorOptions($event)" [countryCode]="countryCode" [participatingCountry]="participatingCountry"></app-sponsor-search>
            </div>
        </div>
    </div>
    <!-- Sponsor Info section Ends -->

    <!-- Communication Disclosure Section Starts-->
    <div class="row-sameheight-block mtb-20" *ngIf="orderFormGroup.value.orderType === orderTypeFBO && isFBOEnrollmentEligible">
        <div class="flex-left-40 border-around">
            <div class="row margin-5">
                <div class="col-xs-12 mb-5"><span
                        class="color-blue">{{'order.Communication Disclosure' | translate | translateKey | uppercase}}</span>
                </div>
            </div>
            <div class="col-xs-12 disclosure-text">
                <div>
                    <p>{{'order.Communication Disclosure Text'| translate | translateKey}}
                        <strong>{{'order.Communication Disclosure Bold Text'| translate | translateKey}}</strong></p>
                </div>
                <div>
                    <p>
                        <strong><u>{{'order.Updating Reference'| translate | translateKey}}</u></strong>
                        {{'order.Updating Reference Text'| translate | translateKey}}</p>
                </div>
            </div>
        </div>
    </div>
    <!-- Communication Disclosure Section Ends-->

    <!-- Communication Preference Section Starts-->
     <!-- <div class="row-sameheight-block mtb-20" *ngIf="orderFormGroup.value.orderType === orderTypeFBO && isFBOEnrollmentEligible">
        <div class="flex-left-40 border-around">
            <div class="row margin-5">
                <div class="col-xs-12 mb-5"><span
                        class="color-blue">{{'order.Communication Preference' | translate | translateKey | uppercase}}</span>
                </div>
            </div>
            <div class="row">
                <div class="check-box-align">
                    <span>{{'order.I want to be contacted by my Sponsor'| translate | translateKey}}</span></div>
                <div class="col-12 form-check pl-0">
                    <label class="check-lbl form-check-box check-box-align" tabindex="-1">
                        <input type="radio" #contactsponsor tabindex="-1" [value]="true" name="isContactSponsor"
                            formControlName="isContactSponsor" (change)="checkContactSponsor()">
                        <span class="label-text"></span>
                        <span tabindex="0" role="radio" (keyup.enter)="contactsponsor.click()" class="form-check-text">{{"order.Yes" | translate |
                                    translateKey}}</span>
                    </label>
                </div>
                <div class="col-12 form-check px-0 my-2">
                    <label class="check-lbl form-check-box check-box-align" tabindex="-1">
                        <input type="radio" #contactsponsor tabindex="-1" [value]="false" name="isContactSponsor"
                            formControlName="isContactSponsor" (change)="checkContactSponsor()">
                        <span class="label-text"></span>
                        <span tabindex="0" role="radio" (keyup.enter)="contactsponsor.click()" class="form-check-text">{{"order.No" | translate |
                                    translateKey}}</span>
                    </label>
                </div>
                <div class="alert-msg py-2 check-box-align"
                    *ngIf="orderFormGroup.value && orderFormGroup.value.isContactSponsor === null && isSubmitted">
                    {{'order.Please select your Communication Preferences.' | translate | translateKey}}
                </div>
            </div>
        </div>
    </div> -->
    <!-- Communication Preference section Ends -->

    <!-- Delivery Info Section Starts-->
    <div class="row-sameheight-block" *ngIf="orderFormGroup.value.orderType === orderTypeFBO && isFBOEnrollmentEligible">
         <div class="flex-left-40">
            <div class="">
                <!-- radio button groups and ship to section -->
                 <div class="row-sameheight-block mtb-20 deliveryoption-block">
                    <div class="column-equal grayborder-1 flex-left-40 widget-border">
                        <div class="row margin-5">
                            <div class="col-xs-4"><span class="color-blue">{{'order.DELIVERY OPTION' |translate
                                    |translateKey}}</span></div>

                            <div class="col-xs-8">
                                <div class="radiobutton-group">
                                    <input *ngIf="shippingDeliveryOptionAvailable"
                                        [attr.disabled]="disableDelivery?'':null" id="delivery" type="radio"
                                        [value]="deliveryPreference.DELIVERY" name="deliveryPreference"
                                        formControlName="deliveryPreference" (change)="deliveryPreferenceOnChange()"
                                        [checked]="orderFormGroup.value.deliveryPreference==deliveryPreference.DELIVERY">
                                    <label *ngIf="shippingDeliveryOptionAvailable" class="pr-30" for="delivery">{{'order.Delivery'
                                        |translate |translateKey}}</label>


                                    <input *ngIf="shippingAddressInfoConfig && !shippingAddressInfoConfig.pudoLocationsEnabled && pickupDeliveryOptionAvailable" id="pickup" type="radio"
                                        [value]="deliveryPreference.PICKUP" name="deliveryPreference"
                                        formControlName="deliveryPreference" (change)="deliveryPreferenceOnChange()"
                                        [checked]="orderFormGroup.value.deliveryPreference==deliveryPreference.PICKUP">
                                    <label *ngIf="shippingAddressInfoConfig && !shippingAddressInfoConfig.pudoLocationsEnabled && pickupDeliveryOptionAvailable" class="pr-30" for="pickup">{{'order.Pick
                                        Up' |translate |translateKey}}</label>

                                        <input *ngIf="shippingAddressInfoConfig && shippingAddressInfoConfig.dropShipLocationsEnabled && dropShipOptionAvailable" id="dropShip" type="radio" [value]="deliveryPreference.DROPSHIP" name="deliveryPreference" formControlName="deliveryPreference" (change)="deliveryPreferenceOnChange()" [checked]="orderFormGroup.value.deliveryPreference==deliveryPreference.DROPSHIP">
                                        <label *ngIf="shippingAddressInfoConfig && shippingAddressInfoConfig.dropShipLocationsEnabled && dropShipOptionAvailable" class="pr-30" for="dropShip">{{'order.Drop ship' |translate |translateKey}}</label>

                                        <input *ngIf="shippingAddressInfoConfig && shippingAddressInfoConfig.pudoLocationsEnabled && pudoShippingMethod && pickupDeliveryOptionAvailable" id="dropShip" type="radio"
                                        [value]="deliveryPreference.DROPSHIP" name="deliveryPreference"
                                        formControlName="deliveryPreference"
                                        (change)="deliveryPreferenceOnChange()"
                                        [checked]="orderFormGroup.value.deliveryPreference==deliveryPreference.DROPSHIP">
                                    <label *ngIf="pickupDeliveryOptionAvailable && pudoShippingMethod" class="pr-30"
                                        for="dropShip">{{pudoShippingMethod.shippingMethodDisplayName}}
                                    </label>
                                    <!-- DROPSHIP Option for Non Scandian Countries -->
                                    <input *ngIf="isDropShipOptionExist && dropshipPudoShippingMethod" id="dropShip" type="radio"
                                    [value]="deliveryPreference.DROPSHIP" name="deliveryPreference"
                                    formControlName="deliveryPreference"
                                    (change)="deliveryPreferenceOnChange()"
                                    [checked]="orderFormGroup.value.deliveryPreference==deliveryPreference.DROPSHIP">
                                    <label *ngIf="isDropShipOptionExist && dropshipPudoShippingMethod" class="pr-30"
                                    for="dropShip">{{dropshipPudoShippingMethod.shippingMethodDisplayName}}</label>
                                    <!-- PICKUP Option for Scandian & BGR Countries -->
                                    <input *ngIf="isPickUpOptionExist && (!shippingAddressInfoConfig.dropShipLocationsEnabled && shippingAddressInfoConfig.pudoLocationsEnabled)" id="pickup" type="radio" [value]="deliveryPreference.PICKUP" name="deliveryPreference" formControlName="deliveryPreference" (change)="deliveryPreferenceOnChange()" [checked]="orderFormGroup.value.deliveryPreference==deliveryPreference.PICKUP">
                                    <label *ngIf="isPickUpOptionExist && (!shippingAddressInfoConfig.dropShipLocationsEnabled && shippingAddressInfoConfig.pudoLocationsEnabled)" class="pr-30" for="pickup">{{'order.Pick
                                        Up' |translate |translateKey}}</label>
                                    <div *ngIf="dropShipDeliveryOptionDisabled" class="form-check pl-0">
                                        <label for="pickup" role="radio"
                                            attr.aria-label="{{'checkout.Shipping method as pickup' | translate}}" tabindex="0">
                                            <span class="label-text">{{'common.PUDO option is temporarily disabled' | translate}}</span>
                                        </label>
                                     </div>
                                </div>
                            </div>
                        </div>
                        <div class="margin-5-20">
                            <!-- Add new Shipping Address -->
                            <div *ngIf="(orderFormGroup.value.deliveryPreference===deliveryPreference.DELIVERY || orderFormGroup.value.deliveryPreference===deliveryPreference.DROPSHIP) && shippingAddressInfoConfig">
                                <div class="address-form">
                                    <!-- Add New Address Form Start-->
                                    <div *ngIf="showAddressForm && (orderFormGroup.value.deliveryPreference===deliveryPreference.DELIVERY)">
                                        <app-address-new class="shipping-address-schema"
                                            [schemaClass]="'shipping-address-schema'"
                                            (addressSubmit)="saveShippingAddress($event)"
                                            [schemaUrl]="shippingSchemaUrl" [countryCode]="countryCode"
                                            [isShippingAddressSchemaform]="true"
                                            [storeConfig]="storeInfo"
                                            [participatingCountry]="participatingCountry"
                                            [preloadAddress]="address || mailingAddress" [onCountryChange]="true"
                                            [isEnableVerifyButton]="true" (addressHidden)="showShippingAddress = $event"
                                            [skipAddressVerification]="appConfig.skipAddressVerification"
                                            (addressInputChanged)="addressChangedByUser($event)">
                                        </app-address-new>
                                    </div>
                                    <!-- Add New Address Form End-->
                                     <!-- Add New Pudo shipping Address Form Start-->

                                     <div *ngIf="showPudoPickupPersonAddressForm && !showSavedAddress && !showDropShipPersonAddressForm">
                                        <div>
                                            <h3 class="title">{{'checkout.Enter Details for the Person Picking up this Order' | translate | translateKey}}</h3>
                                        </div>
                                        <div class="mr-2 text-right">
                                            <span>{{'checkout.Clear and Add New Details?' | translate | translateKey}}</span>
                                            <span><a class="link--light"
                                                tabindex="0" (keyup.enter)="addNewAddress()" (click)="addNewAddress()" >&nbsp;{{'checkout.Click here' | translate | translateKey}}</a></span>
                                        </div>
                                        <app-pudo-address class="shipping-address-schema" *ngIf="displayPudoAddress && (orderFormGroup.value.deliveryPreference===deliveryPreference.DROPSHIP)" [schemaClass]="'shipping-address-schema'"
                                            (addressSubmit)="savePudoShippingAddress($event)" [isShippingAddressSchemaform]="true"
                                            [schemaUrl]="shippingSchemaUrl" [countryCode]="countryCode" [preloadAddress]="pudoAddress"
                                            [storeConfig]="storeInfo" [isEnableVerifyButton]="true"
                                            [skipAddressVerification]="skipAddressVerification"
                                            (addressIsValid)="getAddressIsValid($event)"
                                            (addressSubmitOnInputChange)="pudoAddressInputChange($event)"
                                            [isInputChangeRequired]="true"
                                            (addressInputChanged)="addressChangedByUser($event)">
                                        </app-pudo-address>
                                    </div>
                                    <!-- Add New Pudo shipping Address Form End-->
                                    <!-- Add New Drop Ship Address Form Start-->
                                    <div *ngIf="showDropShipPersonAddressForm">
                                        <div>
                                            <h3 class="title">{{'checkout.Enter Details for the Person Drop Ship this Order' | translate | translateKey}}</h3>
                                        </div>
                                        <div class="mr-2 text-right">
                                            <span>{{'checkout.Clear and Add New Details?' | translate | translateKey}}</span>
                                            <span><a class="link--light"
                                                tabindex="0" (keyup.enter)="addNewAddress()" (click)="addNewAddress()" >&nbsp;{{'checkout.Click here' | translate | translateKey}}</a></span>
                                        </div>
                                        <app-pudo-address class="shipping-address-schema" *ngIf="displayDropAddress" [schemaClass]="'shipping-address-schema'"
                                            (addressSubmit)="savePudoShippingAddress($event)" [isShippingAddressSchemaform]="true"
                                            [schemaUrl]="shippingSchemaUrl" [countryCode]="countryCode" [preloadAddress]="pudoShippingAddressInfo"
                                            [storeConfig]="storeInfo" [isEnableVerifyButton]="true"
                                            [skipAddressVerification]="skipAddressVerification"
                                            (addressIsValid)="getAddressIsValid($event)"
                                            (addressSubmitOnInputChange)="pudoAddressInputChange($event)"
                                            [isInputChangeRequired]="true"
                                            (addressInputChanged)="addressChangedByUser($event)">
                                        </app-pudo-address>
                                    </div>
                                    <!-- Add New Drop Ship Address Form End-->
                                </div>
                                <!-- Ship To Different Address Button Section Starts-->
                                 <div class="verified-address pointer my-3"
                                    [class.align-verified-address]="!showAddressForm">
                                    <div class="saveAddress">
                                        <div class="customFocus">
                                            <input checked formControlName="saveForFutureUse" id="addtoSavedAddresses"
                                                tabindex="0" type="checkbox">
                                            <label
                                                for="{{'customer-service.Add to Saved Addresses' |translate |translateKey}}">
                                                &nbsp;{{'customer-service.Add to Saved Addresses' |translate |translateKey}}
                                            </label>
                                        </div>

                                    </div>
                                    <div *ngIf="(shippingAddressInfo && shippingAddressInfo !== null) && !isNewCard">
                                        <span class="verified" *ngIf="shippingAddressInfo?.addressVerified === true">
                                            <i class="fa fa-check verified-symbol" aria-hidden="true">
                                                {{'customer-service.Verified' |translate |translateKey}}</i>
                                        </span>
                                        <span class="notverified"
                                            *ngIf="shippingAddressInfo?.addressVerified === false || (shippingAddressInfo && !shippingAddressInfo?.addressVerified)">
                                            <i class="fa fa-times verified-symbol" aria-hidden="true">
                                                {{'customer-service.Not Verified' |translate |translateKey}}</i>
                                        </span>

                                    </div>
                                    <div class="col-xs-12 no-padding" *ngIf="showAddressForm && storeInfo
                                    && checkoutConfig && checkoutConfig.displaySearchAddressSection &&  !checkoutConfig.hideSearchAddressLink">
                                        <span>{{'checkout.Don’t see a match?' | translate | translateKey}}</span>
                                        <span (click)="enableAddressFields('shipping-address-schema')"><a
                                                class="link--light"
                                                tabindex="0">{{'checkout.Click here' | translate | translateKey}}</a></span>
                                        <span>{{'checkout.to enter address' | translate | translateKey}}</span>
                                    </div>
                                </div>
                                <!-- Ship To Different Address Button Section Ends-->
                                <div
                                    *ngIf="!showSavedAddress && !showPudoAddressForm && shippingAddressInfoConfig && shippingAddressInfoConfig.pudoLocationsEnabled && orderFormGroup.value.deliveryPreference==deliveryPreference.PICKUP">
                                    <div>
                                        <div class="head-padding">
                                            <h3 class="title">{{'checkout.Select Your Pick Up Location Near By' | translate | translateKey}}</h3>
                                        </div>
                                        <div *ngIf="pudoShippingAddressInfo" class="mb-5">
                                            <div class="col-5">
                                                <div class="" tabindex="0">
                                                    <b>{{pudoShippingAddressInfo.firstName}}&nbsp;{{pudoShippingAddressInfo.lastName}}</b>
                                                </div>
                                                <div tabindex="0">{{pudoShippingAddressInfo.addressLine1}}, {{pudoShippingAddressInfo.city}}</div>
                                                <div tabindex="0"><span *ngIf="checkoutConfig.showStateCode">{{pudoShippingAddressInfo.state}},</span>
                                                    <span> {{pudoShippingAddressInfo.postalCode}} {{pudoShippingAddressInfo.country}}</span>
                                                </div>
                                            </div>
                                            <div class="col-7 text-right">
                                                <span>{{'checkout.Enter different address?' | translate | translateKey}}</span>
                                                <span (click)="addNewPudoShippingAddress()"><a class="link--light" tabindex="0">&nbsp;{{'checkout.Click
                                                        here' | translate | translateKey}}</a></span>
                                            </div>
                                        </div>
                                        <div class="col-xs-12 pickup-locations">
                                            <div *ngIf="pudoLocationsNotFound" class="text-red">
                                                {{'Pickup locations not found for the selected address'}}.
                                            </div>
                                            <div *ngFor="let collectionPoint of pudoCollectionPoints" class="xyz">
                                                <div class="row mb-10" *ngIf="collectionPoint">
                                                    <div class="col-xs-1 no-padding"><input formControlName="shipMethodId" name="shipMethodId"
                                                            [value]="collectionPoint.externalId" type="radio"
                                                            (change)="selectPudoCollectionPoint(collectionPoint)">
                                                    </div>
                                                    <div class="col-xs-8">
                                                        <div>
                                                            <span class="bold">{{collectionPoint.name}}</span><br />
                                                            <span>{{collectionPoint.street}},
                                                                {{collectionPoint.street}}
                                                            </span><br />
                                                            <span>{{collectionPoint?.city}},
                                                                {{collectionPoint?.zipCode}}
                                                            </span><br />
                                                            <span>{{collectionPoint?.country}}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="col-xs-2 text-center">
                                                        <div *ngIf = "shippingAddressInfoConfig.dropShipLocationsEnabled && showDistance"style="font-size: small;">{{collectionPoint.distance * 1000 }}{{'m'}}</div>
                                                        <a *ngIf="collectionPoint.geoPoint && collectionPoint.geoPoint?.latitude && collectionPoint.geoPoint?.longitude" class="pick-up" target="_blank"
                                                            tabindex="0" (keyup.enter)="getPudoLocationMap(collectionPoint.geoPoint)"
                                                            [href]="getPudoLocationMap(collectionPoint.geoPoint) || '#'"
                                                            [ngStyle]="{'pointer-events': getPudoLocationMap(collectionPoint.geoPoint) ? 'auto' : 'none'}">
                                                            <img class="pickup-methods__map-icon" imgSrc="/images/google-maps-icon.png"
                                                                alt="google map icon">
                                                        </a>
                                                        <app-business-hour-preview [businessHours]="collectionPoint.businessHours"
                                                            *ngIf="collectionPoint && collectionPoint.businessHours">
                                                        </app-business-hour-preview>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                             </div>
                            <div *ngIf="shippingAddressInfoConfig && (!shippingAddressInfoConfig.pudoLocationsEnabled || isPickUpOptionExist) && orderFormGroup.value.deliveryPreference==deliveryPreference.PICKUP">
                                <div class="col-xs-12 pickup-locations">
                                    <div *ngFor="let shipMethodInfo of shippingMethods">
                                        <div class="row mb-10" *ngIf="shipMethodInfo.pickUpLocation">
                                            <div class="col-xs-1 no-padding"><input formControlName="shipMethodId"
                                                    name="shipMethodId" value="{{shipMethodInfo.shippingMethodId}}"
                                                    type="radio" (change)="selectShippingMethod(shipMethodInfo)">
                                            </div>
                                            <div class="col-xs-11 no-padding">
                                                <div>
                                                    <span
                                                        class="bold">{{shipMethodInfo.shippingMethodDisplayName}}</span><br />
                                                    <span>{{shipMethodInfo.pickUpLocation?.addressLine1}},
                                                        {{shipMethodInfo.pickUpLocation?.addressLine2}}</span><br />
                                                    <span>{{shipMethodInfo.pickUpLocation?.city}},
                                                        {{shipMethodInfo.pickUpLocation?.state}},
                                                        {{shipMethodInfo.pickUpLocation?.zip}}</span><br />
                                                    <span>{{shipMethodInfo.pickUpLocation?.country}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </div>
    </div>
    <!-- Delivery Info Section ends-->
    <div clss="row-sameheight-block">
    <div class="col-xs-12 mb-5 payment-details pudo-locations-block"
    *ngIf="orderFormGroup.value.deliveryPreference===deliveryPreference.DROPSHIP && shippingAddressInfoConfig && (shippingAddressInfoConfig.pudoLocationsEnabled || shippingAddressInfoConfig.dropShipLocationsEnabled || isDropShipOptionExist)">
        <!-- PUDO PICKUP LOCATIONS START -->
        <div class="border-outline shipping-method__min-height-155 position-relative">
            <div>
                <h3 *ngIf = "(shippingAddressInfoConfig.pudoLocationsEnabled || isDropShipOptionExist)" class="title">{{'checkout.Search and Select Pickup Location' | translate | translateKey}}</h3>
                <h3 *ngIf = "shippingAddressInfoConfig.dropShipLocationsEnabled" class="title">{{'checkout.Search and Select Drop Location' | translate | translateKey}}</h3>
            </div>
            <div class="mr-2 text-right">
                <span>{{'checkout.New Search?' | translate | translateKey}}</span>
                <span (click)="clearPudoLocationSearchForm()"><a class="link--light" tabindex="0">&nbsp;{{'checkout.Click
                        here' | translate | translateKey}}</a></span>
            </div>
            <div class="text-center my-2" *ngIf="(hidePudoPickupLocationsButton && !pudoCollectionPoints) || isDropShipOptionExist">
                <button role="button" tabindex="0" (click)="loadPUDOLocations()" type="button"
                    class="btn blue-button" [disabled]="!formPickupPersonAddressValid">
                    <span *ngIf="shippingAddressInfoConfig.dropShipLocationsEnabled">{{'common.Get Drop Locations' |translate |translateKey}}</span>
                    <span *ngIf="shippingAddressInfoConfig.pudoLocationsEnabled|| isDropShipOptionExist">{{'common.Get Pickup Locations' |translate |translateKey}}</span>
                <!-- pudo pickup locations loading spinner start -->
                <span *ngIf="loadingPudoPickupLocations" tabindex="0"
                class="personal-info--email-info sponsor-loader--btn">
                <i class="fa fa-spinner"></i></span>
            <!-- pudo pickup locations loading spinner end --> 
                </button>
            </div> 

            <!-- PUDO PICKUP LOCATION SEARCH START -->
            <form *ngIf="pudoLocationSearchForm" [formGroup]="pudoLocationSearchForm">
                <div class="pudo-form-align" *ngIf="!hidePudoPickupLocationsButton">
                    <div
                    class="pl-2 form-group col-xs-6 padding-left-0 floating-input floatLabelContainer">
                    <input id="addressLine1" tabindex="0" float-label role="textbox" formControlName="addressLine1"
                        (change)="pudoLocationsNotFound = false" class="form-control"
                        placeholder="{{'checkout.Address Line 1' | translate}}" type="text">
                </div>
                <div
                class="pl-2 form-group col-xs-6 padding-left-0 floating-input floatLabelContainer">
                    <input id="city" tabindex="0" float-label role="textbox" formControlName="city" aria-required="true"
                        (change)="pudoLocationsNotFound = false" attr.aria-label="{{'checkout.City' | translate | translateKey}}"
                        class="form-control" placeholder="{{'checkout.City' | translate | translateKey}}{{' *'}}" type="text">
                        <span class="error"
                        *ngIf="pudoLocationSearchForm && pudoLocationSearchForm.controls['city'] && !pudoLocationSearchForm.controls['city'].valid && pudoLocationSearchForm.controls['city'].touched">{{'common.Required'
                        | translate | translateKey}}
                    </span>
                </div>

                  <div class="pl-2 form-group col-xs-6 padding-left-0 floating-input floatLabelContainer">
                        <input id="zipCode" tabindex="0" float-label role="textbox" formControlName="zipCode"
                            attr.aria-label="{{'checkout.Zip Code' | translate | translateKey}}" aria-required="true"
                            (change)="pudoLocationsNotFound = false" class="form-control"
                            placeholder="{{'checkout.Zip code' | translate | translateKey}}{{' *'}}" type="text">
                            <div class="error">
                                <span 
                                *ngIf="pudoLocationSearchForm.controls['zipCode'].hasError('pattern')">
                                {{'checkout.Please enter a valid zip code'| translate}}
                               </span>
                               <span 
                                 *ngIf="pudoLocationSearchForm && pudoLocationSearchForm.controls['zipCode'] && !pudoLocationSearchForm.controls['zipCode'].valid && pudoLocationSearchForm.controls['zipCode'].touched">{{'common.Required'
                            | translate}}
                             </span>
                        </div>
                    </div>
                    <div
                        class="form-group col-xs-6 padding-left-0 floating-input floatLabelContainer">                        
                        <select float-label attr.data-placeholder="{{'checkout.Country' | translate}}"
                        role="listbox" name="country" class="form-control"
                        formControlName="country" disabled>
                            <option *ngFor="let country of countries" [ngValue]="country.isocodeThree" 
                            role="option" >{{country.name}}</option>
                        </select>                    
                   </div>
                </div>
                <!-- PUDO PICKUP LOCATIONS START-->
                <div class="col-xs-12 pickup-locations"
                    *ngIf="pudoCollectionPoints">
                    <div class="overflow-scroll">
                        <div *ngFor="let collectionPoint of pudoCollectionPoints">
                            <div class="row mb-10" *ngIf="collectionPoint">
                                <div class="col-xs-1 no-padding"><input formControlName="externalId" name="externalId"
                                        [value]="collectionPoint.externalId" type="radio"
                                        (change)="selectPudoCollectionPoint(collectionPoint)">
                                </div>
                                <div class="col-xs-8">
                                    <div>
                                        <span class="bold">{{collectionPoint.name}}</span><br />
                                        <span>{{collectionPoint.street}},
                                            {{collectionPoint.houseNumber}}
                                        </span><br />
                                        <span>{{collectionPoint?.city}},
                                            {{collectionPoint?.zipCode}}
                                        </span><br />
                                        <span>{{collectionPoint?.country}}
                                        </span>
                                    </div>
                                </div>
                                <div class="col-xs-2 text-center">
                                    <div style="font-size: small;" *ngIf="showDetail">{{collectionPoint.distance * 1000 }}{{'m'}}</div>
                                    <a *ngIf="collectionPoint.geoPoint && collectionPoint.geoPoint?.latitude && collectionPoint.geoPoint?.longitude" class="pick-up" target="_blank"
                                        tabindex="0" (keyup.enter)="getPudoLocationMap(collectionPoint.geoPoint)"
                                        [href]="getPudoLocationMap(collectionPoint.geoPoint) || '#'"
                                        [ngStyle]="{'pointer-events': getPudoLocationMap(collectionPoint.geoPoint) ? 'auto' : 'none'}">
                                        <img class="pickup-methods__map-icon" imgSrc="/images/google-maps-icon.png"
                                            alt="google map icon">
                                    </a>
                                    <app-business-hour-preview [businessHours]="collectionPoint.businessHours"
                                        *ngIf="collectionPoint && collectionPoint.businessHours">
                                    </app-business-hour-preview>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- PUDO PICKUP LOCATIONS END-->
            </form>
            <ng-container *ngIf="pudoLocationsNotFound && !pudoCollectionPoints">
                <div class="my-3 error">
                    <p *ngIf = "shippingAddressInfoConfig.pudoLocationsEnabled">{{'checkout.Pickup locations not found for current search' | translate|translateKey}}.</p>
                    <p *ngIf = "shippingAddressInfoConfig.dropShipLocationsEnabled">{{'checkout.Drop locations not found for current search' | translate|translateKey}}.</p>
                </div>
            </ng-container>

            <!-- GET PICKUP LOCATIONS BTN START -->
            <div class="text-center my-2" *ngIf="!pudoCollectionPoints && pudoLocationSearchForm&& !hidePudoPickupLocationsButton">
                <button role="button" type="button" class="btn blue-button  get-pick-location-btn" (click)="loadPUDOLocations()" [disabled]="!pudoLocationSearchForm.valid">
                    <span *ngIf="shippingAddressInfoConfig.dropShipLocationsEnabled">{{'common.Get Drop Locations' |translate |translateKey}}</span>
                    <span *ngIf="shippingAddressInfoConfig.pudoLocationsEnabled">{{'common.Get Pickup Locations' |translate |translateKey}}</span>
                    <span *ngIf="loadingPudoPickupLocations" tabindex="0"
                        class="personal-info--email-info sponsor-loader--btn">
                        <i class="fa fa-spinner"></i></span>
                </button>
                <!-- GET PICKUP LOCATIONS BTN END -->
            </div>
        </div>
        <!-- PUDO PICKUP LOCATIONS END -->
    </div>
    </div>
    <!-- Delivery Method and Shipping section starts-->
    <div class="row-sameheight-block mtb-20" *ngIf="orderFormGroup.value.orderType === orderTypeFBO && isFBOEnrollmentEligible">
        <div class="column-equal grayborder-1 flex-left-40">
            <div class="shipmethod-form payment-details"
                [ngClass]="orderFormGroup.value.deliveryPreference!==deliveryPreference.DELIVERY ? 'variable-height': ''">
                <div class="row margin-5"
                    *ngIf="shippingAddressInfoConfig && shippingAddressInfoConfig.isNavigateToDeliverypage">
                    <div class="col-xs-12">
                        <span class="color-blue" *ngIf="orderFormGroup.value.deliveryPreference==deliveryPreference.DELIVERY">
                            {{'order.DELIVERY METHOD' |translate |translateKey}}
                        </span>
                        <span *ngIf="orderFormGroup.value.deliveryPreference==deliveryPreference.DROPSHIP" class="color-blue">
                        {{'order.DROPSHIP METHOD' |translate |translateKey}}
                        </span>
                    </div>
                    <div class="col-xs-12 margin-5-10 padding-0 floating-input"
                        *ngIf="(orderFormGroup.value.deliveryPreference===deliveryPreference.DELIVERY || (orderFormGroup.value.deliveryPreference==deliveryPreference.DROPSHIP && shippingAddressInfoConfig.dropShipLocationsEnabled)) && shippingMethods && shippingMethods.length > 0 ">
                        <div *ngFor="let shippingMethod of shippingMethods;let i=index;">
                            <div class="form-group col-xs-6"  *ngIf="!shippingMethod.pudoEnabled">
                                <input type="radio" tabindex="0" id="shippingMethod{{i}}" name="shipMethodId"
                                    [value]="shippingMethod.shippingMethodId" formControlName="shipMethodId"
                                    (click)="selectShippingMethod(shippingMethod)">
                                <span class="label-text"></span>
                                <span class="text">
                                    <ng-container *ngIf="appConfig && appConfig.enableVatItemizationForNonVat">
                                        {{shippingMethod.shippingMethodDisplayName}} ({{shippingMethod.shippingCharge + shippingMethod.shippingTax
                                            | currencyFormat:storeInfo}})
                                    </ng-container>
                                    <ng-container *ngIf="!(appConfig && appConfig.enableVatItemizationForNonVat)">
                                        {{shippingMethod.shippingMethodDisplayName}} ({{shippingMethod.shippingCharge
                                            | currencyFormat:storeInfo}})
                                    </ng-container>
                                    <ng-container *ngIf="shippingMethod.freeShippingEligible">
                                        {{'order.Promotional FREE Delivery' |translate |translateKey}}
                                    </ng-container>
                                    <span *ngIf="!shippingMethod.pickUpLocation" class="icon">
                                        <span tabindex="-1" role="tooltip"
                                            attr.aria-label="{{shippingMethod.shipmethodDescription}}"
                                            [popover]="shippingDescription" class="shipping-method" placement="bottom"
                                            [outsideClick]="true" container="body"
                                            containerClass="delivery-method--popover">
                                            <i class="fa fa-question-circle-o"></i>
                                        </span>
                                        <ng-template #shippingDescription>
                                            <div class="p-2">
                                                <div>
                                                    <b>{{'common.Description' | translate
                                                        |translateKey}}</b>

                                                </div>
                                                <div>{{shippingMethod.shipmethodDescription}}</div>
                                            </div>
                                        </ng-template>
                                    </span>
                                </span>
                            </div>
                        </div>
                        <div class="alert-msg"
                            *ngIf="!orderFormGroup.controls['shipMethodId'].valid && (orderFormGroup.controls['shipMethodId'].touched || isSubmitted)">
                            {{'order.Shipping Method is Mandatory' |translate |translateKey}}</div>

                    </div>
                    <div class="padding-15"
                        *ngIf="orderFormGroup.value.deliveryPreference!==deliveryPreference.DELIVERY || (shippingMethods && shippingMethods.length === 0 && !shipMethodValidation)">
                        N/A
                    </div>
                    <div class="alert-msg" *ngIf="shipMethodValidation">{{shipMethodValidation.message}}</div>
                </div>
                <div class="row margin-5">
                    <div class="col-xs-12"><span class="color-blue">{{'order.SHIPPING COST' |translate
                            |translateKey}}</span></div>

                    <div class="col-xs-12 margin-5-10 form-group">
                        <div class="radiobutton-group">
                            <input id="addnew_shppingCost" formControlName="shippingCostSelector"
                                name="shippingCostSelector" value="1" type="radio" (change)="shippingCostChange()">
                            <label class="pr-30" for="addnew_shppingCost">{{'order.Original price'
                                |translate |translateKey}}</label>

                            <input id="addnew_shppingCost" formControlName="shippingCostSelector"
                                name="shippingCostSelector" value="2" type="radio" (change)="shippingCostChange()" *ngIf="originalShippingCost > 0">
                            <label class="pr-25" for="addnew_shppingCost" *ngIf="originalShippingCost > 0">{{'order.Discounted
                                Amount'|translate |translateKey}}</label>

                            <input id="choosefromlist_shippingCost" formControlName="shippingCostSelector"
                                name="shippingCostSelector" value="3" type="radio" (change)="shippingCostChange()" *ngIf="originalShippingCost > 0">
                            <label class="" for="choosefromlist_shippingCost" *ngIf="originalShippingCost > 0">{{'order.Discount
                                Percentage'|translate |translateKey}}</label>

                        </div>
                    </div>
                </div>
                <div class="row margin-5-10">
                    <div class="col-xs-5">
                        <div class="form-group"
                            *ngIf="orderFormGroup.controls['shippingCostSelector'].value == selectEnum.firstOption">
                            <input type="number" min="0" class="form-control width-92"
                                placeholder="{{'order.Shipping Cost' |translate |translateKey}}"
                                formControlName="originalShippingCost" (keypress)="allowOnlyNumbers($event)" disabled>
                            <span class="amount-symbol">
                                <span> {{storeInfo?.currencySymbol || defaultCurrency}}</span>
                            </span>
                        </div>
                        <div class="form-group"
                            *ngIf="orderFormGroup.controls['shippingCostSelector'].value == selectEnum.secondOption">
                            <input type="number" min="0" class="form-control width-92"
                                placeholder="{{'order.Discounted Amount' |translate |translateKey}}"
                                formControlName="shippingCost" (keypress)="keyEventShippingCost($event)" step="0.01"
                                (change)="getShippingCostInPercentage()">
                            <span class="amount-symbol">
                                <span>{{storeInfo?.currencySymbol || defaultCurrency}}</span>
                            </span>
                            <div class="alert-msg"
                                *ngIf="!orderFormGroup.controls['shippingCost'].valid && orderFormGroup.controls['shippingCost'].hasError('required') && (orderFormGroup.controls['shippingCost'].touched || isSubmitted)">
                                {{'order.Discounted Amount is Mandatory' |translate |translateKey}}</div>

                            <div class="alert-msg"
                                *ngIf="!orderFormGroup.controls['shippingCost'].valid && orderFormGroup.controls['shippingCost'].hasError('amountValidation') && (orderFormGroup.controls['shippingCost'].touched || isSubmitted)">
                                {{'order.Enter valid Amount' |translate |translateKey}}</div>

                        </div>
                        <div class="form-group"
                            *ngIf="orderFormGroup.controls['shippingCostSelector'].value == selectEnum.thirdOption">
                            <input type="number" min="0" max="100" class="form-control"
                                (change)="getShippingCostInPercentage()"
                                placeholder="{{'order.Shipping Cost Percentage' |translate |translateKey}}"
                                formControlName="shippingCostPercentage" (keypress)="shippingPercentChange($event)">
                            <span class="amount-symbol">
                                <span class="fa fa-percent"></span>
                            </span>
                            <div class="alert-msg"
                                *ngIf="!orderFormGroup.controls['shippingCostPercentage'].valid && (orderFormGroup.controls['shippingCostPercentage'].touched || isSubmitted)">
                                {{'order.Shipping Cost Percentage is Mandatory' |translate |translateKey}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Delivery Method and Shipping section ends-->
    <!-- Payment section starts-->
     <div class="row-sameheight-block mtb-20" *ngIf="orderFormGroup.value.orderType === orderTypeFBO && isFBOEnrollmentEligible">
        <div class="column-equal grayborder-1 flex-left-40 payment-details payment-details-block"
            [ngClass]="+orderFormGroup.controls['paymentSelector'].value === selectEnum.thirdOption || paymentTypeEnum.Orange_Money? 'variable-height' : ''">
            <div class="row margin-5">
                <div class="col-xs-3 radiobutton-label">
                    <span class="color-blue">{{'order.PAYMENT DETAILS' | translate | translateKey}}</span>
                </div>
                <div class="col-xs-9 radio-buttons">
                    <div class="radiobutton-group">
                        <span *ngIf="credit_Card_show">
                            <input #creditCardPayment id="creditCardPayment" formControlName="paymentSelector"
                                name="paymentSelector" value="1" type="radio" (change)="onPaymentMethodChnage()">
                            <label class="pr-30">{{'order.Credit Card'| translate | translateKey}}</label>
                        </span>
                        <span  *ngIf="wire_Transfer_show">
                            <input #wireTransferPayment id="wireTransferPayment" formControlName="paymentSelector"
                            [checked]="+orderFormGroup.controls['paymentSelector'].value == paymentTypeEnum.Wire_Transfer" 
                                name="paymentSelector" [value]="paymentTypeEnum.Wire_Transfer" type="radio" (change)="onPaymentMethodChnage()">
                            <label class="pr-30">{{'checkout.Wire Transfer'| translate | translateKey}}</label>
                        </span>
                        <span #eCheckPayment id="eCheckPayment" *ngIf="echeck_show">
                            <input id="eCheck" formControlName="paymentSelector" name="paymentSelector" value="2"
                                type="radio" (change)="onPaymentMethodChnage()">
                            <label class="pr-30" for="eCheck">{{'order.ECheck'| translate
                                |translateKey}}</label>

                        </span>
                        <span *ngIf="money_Order_show && !appConfig.displayStatementForWavePayment">
                            <input #moneyOrderPayment id="moneyOrderPayment" formControlName="paymentSelector"
                                name="paymentSelector" value="3" type="radio" (change)="onPaymentMethodChnage()">
                            <label class="pr-30">{{'order.Money Order'| translate | translateKey}}</label>
                        </span>
                        <span *ngIf="money_Order_show && appConfig.displayStatementForWavePayment">
                            <input #moneyOrderPayment id="moneyOrderPayment" formControlName="paymentSelector"
                                name="paymentSelector" value="3" type="radio" (change)="onPaymentMethodChnage()">
                            <label class="pr-30">{{'order.Wave'| translate | translateKey}}</label>
                        </span>
                        <span *ngIf="cash_on_delivery_show">
                            <input #cashOnDeliveryPayment id="cashOnDeliveryPayment" formControlName="paymentSelector"
                                name="paymentSelector" [value]="paymentTypeEnum.Cash_On_Delivery" type="radio"
                                (change)="onPaymentMethodChnage()">
                            <label class="pr-30">{{'order.Cash On Delivery'| translate | translateKey}}</label>
                        </span>
                        <span *ngIf="orange_money_show">
                            <input #orangeMoneyPayment id="orangeMoneyPayment" formControlName="paymentSelector"
                                name="paymentSelector" [value]="paymentTypeEnum.Orange_Money" type="radio"
                                (change)="onPaymentMethodChnage()">
                            <label class="pr-30">{{'order.Orange Money'| translate | translateKey}}</label>
                        </span>
                        <span *ngIf="bank_transfer_show">
                            <input #bankTransferPayment id="bankTransferPayment" formControlName="paymentSelector"
                                name="paymentSelector" [value]="paymentTypeEnum.Bank_Transfer" type="radio"
                                (change)="onPaymentMethodChnage()">
                            <label class="pr-30">{{'checkout.Bank Transfer'| translate | translateKey}}</label>
                        </span>
                        <span *ngIf="ach_show">
                            <input #paymentAch id="paymentAch" formControlName="paymentSelector"
                                name="paymentSelector" [value]="paymentTypeEnum.eCheck" type="radio" (change)="onPaymentMethodChnage()">
                            <label class="pr-30">{{'order.Ach'| translate | translateKey}}</label>
                        </span>
                        <span *ngIf="banContact_misterCash_and_maestro_show">
                          <input #paymentBanContactMisterCashAndMaestro id="paymentBanContactMisterCashAndMaestro" formControlName="paymentSelector"
                              name="paymentSelector" [value]="paymentTypeEnum.BanContact_MisterCash_and_Maestro" type="radio" (change)="onPaymentMethodChnage()">
                          <label class="pr-30">{{'order.BanContact MisterCash & Maestro'| translate | translateKey}}</label>
                      </span>
                      <span *ngIf="misterCash_and_maestro_show">
                        <input #paymentMisterCashAndMaestro id="paymentMisterCashAndMaestro" formControlName="paymentSelector"
                            name="paymentSelector" [value]="paymentTypeEnum.MisterCash_and_Maestro" type="radio" (change)="onPaymentMethodChnage()">
                        <label class="pr-30">{{'order.MisterCash & Maestro'| translate | translateKey}}</label>
                    </span>
                    <span *ngIf="pay_by_link_show">
                        <input #singleDebit id="payByLink" formControlName="paymentSelector"
                            name="paymentSelector" [value]="paymentTypeEnum.Pay_By_Link" type="radio" (change)="onPaymentMethodChnage()">
                        <label class="pr-30">{{'order.Pay By Link'| translate | translateKey}}</label>
                      </span>
                    </div>
                </div>
            </div>
            <div class="row margin-5-10"
                *ngIf="(orderFormGroup.controls['paymentSelector'].value == selectEnum.firstOption) && credit_Card_show">
                <div class="col-xs-12 floating-input customFocus">
                    <div class="border-outline pr-0"
                        *ngIf="paymentComponentSettings.savedCards && paymentComponentSettings.savedCards.length>0">
                        <div class="slim-scroll saved-card" slimScroll width="100%" size="3px" height="inherit"
                            alwaysVisible="true" wheelStep="20">
                            <div class="pr-3">
                                <div class="saved-card__content px-0"
                                    *ngFor="let savedCard of paymentComponentSettings.savedCards; let i = index;">
                                    <div class="">
                                        <div class="form-check pl-0 w-100">
                                            <div class="row no-margin mb-10 paymentdetails-block">
                                                <div class="col-xs-1">
                                                    <input tabindex="0"
                                                        [attr.disabled]="savedCard.expired === true?'':null"
                                                        type="radio" name="paymentInstrumentId"
                                                        formControlName="paymentInstrumentId" [value]="savedCard.id"
                                                        [checked]="savedCard.id==orderFormGroup.controls['paymentInstrumentId'].value"
                                                        (click)="selectSavedCard(savedCard,false)">
                                                    <span class="label-text float-left"></span></div>

                                                <div class="col-xs-11">
                                                    <span class="saved-card__display">
                                                        <span class="saved-card__holder-name bold"
                                                            *ngIf="savedCard.nameOnTheCard">
                                                            {{savedCard.nameOnTheCard}}
                                                        </span>
                                                        <span *ngIf = "!savedCard.notes == 'Default'"
                                                            [ngClass]="{'color-red':savedCard.expired}">{{savedCard.notes}}</span>
                                                        <div class="saved-card__mask line-height-cc"
                                                            *ngIf="savedCard.maskedCard">
                                                            <span
                                                                class="cc-number {{savedCard.cardType | uppercase}} identified card-icon"></span>
                                                            <span class="saved-card__ending">
                                                                {{'common.Ending in' | translate
                                                                |translateKey}}
                                                                <span class="helvetica-bold">{{savedCard.maskedCard
                                                                    | slice:savedCard.maskedCard.length
                                                                    - 4}}</span>
                                                            </span>
                                                        </div>
                                                        <div class="saved-card__expiry"
                                                            *ngIf="savedCard.expiryMonth&&savedCard.expiryYear">
                                                            <span
                                                                class="helvetica-regular">{{'checkout.Expiration' |translate |translateKey}}
                                                            </span>
                                                            {{savedCard.expiryMonth|number:'2.0-0'}}/{{savedCard.expiryYear.toString().substring(2,4)}}
                                                        </div>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-xs-5 pb-3 padding-top-15">
                        <input id="saveCard" name="saveCard" [checked]="savePaymentMethod" tabindex="0" type="checkbox"
                            (click)="savePaymentMethodClicked(savePaymentMethod)">
                        <span
                            class="savecard-label">{{'customer-service.Save Payment details?' |translate |translateKey}}</span>
                    </div>
                    <div class="col-xs-7 pr-0 pb-3 padding-top-15 text-right">
                        <button role="button" attr.aria-label="{{'checkout.Add New Card' | translate | translateKey}}"
                            tabindex="0" (mousedown)="addNewCardClicked = true"
                            (keyup.enter)="selectSavedCard(null,true)" type="button" class="btn blue-button"
                            (click)="selectSavedCard(null,true)"
                            [disabled]="!this.shippingAddressInfo && !this.mailingAddress && !(this.memberInfo && this.memberInfo.address)">
                            <span>+ </span> {{'checkout.Add New Card' |translate |translateKey}}</button>
                    </div>
                </div>
            </div>
            <!-- Wire transfer -->
            <div class="margin-10" *ngIf="(+orderFormGroup.controls['paymentSelector'].value === +paymentTypeEnum.Wire_Transfer) && wire_Transfer_show">
                <span style="font-size: 14px;" *ngIf="!showCustomerWireTransferDetails && bankDetailsCountryList && bankDetailsCountryList.length > 0  && !appConfig.isWireTransferLabelWithoutGmbh">
                    <span *ngFor="let bankDetail of bankDetailsCountryList">
                        <p> {{translateOptions.translateText| translate:translateOptions.translateParams }}</p>
                        <p><label>{{'checkout.Name of Bank-de'| translate}} </label>: <label>{{"checkout."+bankDetail.bankName+'-de' | translate}}</label></p>
                        <p><label>{{'checkout.IBAN'| translate}} </label>: <label>{{bankDetail.iban}}</label></p>
                        <p><label>{{'checkout.BIC'| translate}} </label>: <label>{{bankDetail.bankCode}}</label></p>
                        <p>{{'checkout.Reference the order number on your Wire Transfer payment-de' | translate}}</p>
                        <p>{{'checkout.We will deliver upon receipt of the payment-de' | translate}}</p>
                        <p>{{'checkout.Delivery will be made to the specified delivery address-de' | translate}}</p>
                        <p><b>*{{'checkout.Please note-de' | translate}}</b>: {{'checkout.If we do not receive payment within 14 days, the order will be automatically canceled-de' | translate}}</p>                                    
                        <span class=" my-2">--------------------------------------------------------------------------------------------------------------------------------------------</span>
                        <p> {{translateOptions.translateText| translate:translateOptions.translateParams }}</p>
                        <p><label>{{'checkout.Name of Bank'| translate}} </label>: <label>{{'checkout.'+bankDetail.bankName | translate}}</label></p>
                        <p><label>{{'checkout.IBAN'| translate}} </label>: <label>{{bankDetail.iban}}</label></p>
                        <p><label>{{'checkout.BIC'| translate}} </label>: <label>{{bankDetail.bankCode}}</label></p>
                        <p>{{'checkout.Reference the order number on your Wire Transfer payment' | translate}}</p>
                        <p>{{'checkout.We will deliver upon receipt of the payment' | translate}}</p>
                        <p>{{'checkout.Delivery will be made to the specified delivery address' | translate}}</p>
                        <p><b>*{{'checkout.Please note' | translate}}</b>: {{'checkout.If we do not receive payment within 14 days, the order will be automatically canceled.' | translate}}</p>
                    </span>
                </span>
                <span style="font-size: 14px;" *ngIf="!showCustomerWireTransferDetails && bankDetailsCountryList && bankDetailsCountryList.length > 0  && appConfig.isWireTransferLabelWithoutGmbh">
                    <p> {{translateOptions.translateText| translate:translateOptions.translateParams }}</p>
                    <span *ngFor="let bankDetail of bankDetailsCountryList">
                        <p><label>{{'checkout.Name of Bank'| translate}} </label>:<label>{{'checkout.'+bankDetail.bankName | translate}}</label></p>
                        <p><label>{{'checkout.IBAN'| translate}} </label>: <label>{{bankDetail.iban}}</label></p>
                        <p><label>{{'checkout.BIC'| translate}} </label>: <label>{{bankDetail.bankCode}}</label></p>
                        <span class=" my-2" *ngIf="!isLast">--------------------------------------------------------------------------------------------------------------------------------------------</span>
                    </span>
                    <p>{{'checkout.Reference the order number on your Wire Transfer payment' | translate}}</p>
                    <p>{{'checkout.We will deliver upon receipt of the payment' | translate}}</p>
                    <p>{{'checkout.Delivery will be made to the specified delivery address' | translate}}</p>
                    <p><b>*{{'checkout.Please note' | translate}}</b>: {{'checkout.If we do not receive payment within 14 days, the order will be automatically canceled.' | translate}}</p>
                </span>
                <span *ngIf="showCustomerWireTransferDetails" >
                    <h3 class="title">{{'checkout.Wire Transfer Header' | translate |translateKey}}</h3>
                    <span class="transfer-txt-style">{{'checkout.Wire Transfer Details' | translate|translateKey}}</span>
                </span>
            </div>
            <!-- Pay by link starts -->
            <div class="margin-10"
                *ngIf="(+orderFormGroup.controls['paymentSelector'].value === +paymentTypeEnum.Pay_By_Link) && pay_by_link_show">
                <div class="col p-0 template3 border-outline">
                    <div class="px-4 py-3">
                        <h5 class="pay-by-link-title margin-0">{{'order.Pay By Link' | translate |translateKey}}</h5>
                    </div>
                    <div class="px-4 py-3">
                        <p class="margin-0">{{'order.Customer is paying for the order with pay by link' | translate |translateKey}}
                        </p>
                        <p class="pay-by-link-title margin-0">{{'order.Order wil NOT be shipped until we receive payment' | translate |translateKey}}</p>
                    </div>
                    <form *ngIf="emailForm" [formGroup]="emailForm">
                        <div class="pl-2 form-group col-xs-6 padding-left-0 floating-input floatLabelContainer">
                            <input id="email-input" tabindex="0" float-label role="textbox" formControlName="payByLinkEmail"
                                class="form-control" (input)="emailCheck()" pattern="^[a-zA-Z0-9_+-]+(\.[a-zA-Z0-9_+-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$"
                                placeholder="{{'order.email address' |translate |translateKey}}{{' *'}}" type="text" />
                            <span class="error"
                                *ngIf="emailForm && emailForm.controls['payByLinkEmail'] && !emailForm.controls['payByLinkEmail'].valid && emailForm.controls['payByLinkEmail'].touched">{{'order.Required'
                                | translate | translateKey}}
                            </span>
                            <span tabindex="0" class="error" *ngIf="emailForm.controls['payByLinkEmail'].hasError('pattern')">
                                {{'order.Please enter a valid email address' | translate | translateKey}}
                            </span>
                        </div>
                    </form>
                </div>
            </div>
            <!-- Pay By Link Ends -->
            <!-- Echeck Details -->
            <div class="row margin-5-10"
                *ngIf="(orderFormGroup.controls['paymentSelector'].value == selectEnum.secondOption) && echeck_show">
                <div class="col-xs-12 floating-input">
                    <div class="border-outline pr-0"
                        *ngIf="paymentComponentSettings.savedEChecks && paymentComponentSettings.savedEChecks.length>0">
                        <div class="saved-echeck slim-scroll" slimScroll width="100%" size="3px" height="inherit"
                            alwaysVisible="true" wheelStep="20">
                            <div class="row pr-3">
                                <div class="col-12 col-md-12 px-0 saved-echeck__content"
                                    *ngFor="let savedEcheck of paymentComponentSettings.savedEChecks; let i = index;">
                                    <div class="">
                                        <div class="form-check pl-0 w-100">
                                            <div class="row no-margin mb-10 paymentdetails-block">
                                                <div class="col-xs-1">
                                                    <input tabindex="0" type="radio" name="echeck"
                                                        name="paymentInstrumentId" formControlName="paymentInstrumentId"
                                                        [value]="savedEcheck.id"
                                                        (click)="selectECheck(savedEcheck,false)">
                                                    <span class="label-text"></span>
                                                </div>
                                                <div class="col-xs-11">
                                                    <span class="saved-echeck__echeck">
                                                        <span tabindex="-1">{{'checkout.Ending with
                                                            Account Number:' |translate |translateKey}}
                                                            {{savedEcheck.accountNumber.substr(savedEcheck.accountNumber.length
                                                            - 4)}}
                                                        </span>
                                                        <div>
                                                            {{'checkout.Routing Number' | translate |translateKey}}: {{savedEcheck.routingNumber}}
                                                        </div>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 pb-3 padding-top-15 text-center">
                        <button role="button" attr.aria-label="{{'checkout.Add New ECheck' | translate | translateKey}}"
                            tabindex="0" (keyup.enter)="selectECheck(null,true)" type="button"
                            class="btn blue-button text-center col col-sm-auto" (click)="selectECheck(null,true)">
                            <span class="">+ </span> {{'checkout.Add New ECheck' | translate
                            |translateKey}}</button>

                    </div>
                </div>
            </div>
             <!-- Ach Details -->
             <div class="row margin-5-10" *ngIf="(+orderFormGroup.controls['paymentSelector'].value === +paymentTypeEnum.Ach) && ach_show">
                <h2>Ach Details</h2>
                <div class="col-xs-12 floating-input">
                    <div class="border-outline pr-0" *ngIf="paymentComponentSettings.savedAchs && paymentComponentSettings.savedAchs.length>0">
                        <div class="saved-echeck slim-scroll" slimScroll width="100%" size="3px" height="inherit" alwaysVisible="true" wheelStep="20">
                            <div class="row pr-3">
                                <div class="col-12 col-md-12 px-0 saved-echeck__content" *ngFor="let savedAch of paymentComponentSettings.savedAchs; let i = index;">
                                    <div class="">
                                        <div class="form-check pl-0 w-100">
                                            <div class="row no-margin mb-10 paymentdetails-block">
                                                <div class="col-xs-1">
                                                    <input tabindex="0" type="radio" name="echeck" name="paymentInstrumentId" formControlName="paymentInstrumentId" [value]="savedAch.id" (click)="selectAch(savedAch,false)">
                                                    <span class="label-text"></span>
                                                </div>
                                                <div class="col-xs-11">
                                                    <span class="saved-echeck__echeck">
                                                        <span tabindex="-1">{{'checkout.Ending with
                                                            Account Number:' |translate |translateKey}}
                                                            {{savedAch.accountNumber.substr(savedAch.accountNumber.length
                                                            - 4)}}
                                                        </span>
                                                    <div>{{'checkout.Routing Number' | translate |translateKey}}: {{savedAch.routingNumber}}
                                                    </div>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 pb-3 padding-top-15 text-center">
                        <button role="button" attr.aria-label="{{'checkout.Add New Ach' | translate | translateKey}}" tabindex="0" (keyup.enter)="selectAch(null,true)" type="button" class="btn blue-button text-center col col-sm-auto" (click)="selectAch(null,true)">
                            <span class="">+ </span> {{'checkout.Add New Ach' | translate
                            |translateKey}}</button>

                    </div>
                </div>
            </div>
            <div class="margin-10"
                *ngIf="(+orderFormGroup.controls['paymentSelector'].value === selectEnum.thirdOption) && money_Order_show  && !displayStatementForWavePayment">
                <span style="font-size: 14px;">
                    <span style="font-weight: bold">{{'checkout.Your Order will NOT be shipped until we
                        receive your Money Order.'| translate | translateKey}}
                    </span>
                    {{'checkout.Please write your distributor ID and order number on your money order
                    and mail it to'| translate | translateKey}}:

                    <span style="font-weight: bold" *ngFor="let details of bankDetailsCountryList">{{'checkout.Forever Living'| translate
                        |translateKey}}{{'checkout.com'| translate | translateKey}},
                        <span *ngIf="details.addressLine1" > {{details.addressLine1}},</span>
                        <span *ngIf="details.city" > {{details.city}}</span>
                        <span *ngIf="details.state">  {{details.state}}</span>
                        <span *ngIf="details.zipCode">  {{details.zipCode}}</span>
                    </span>
                    {{'checkout.If we do not receive your Money Order within 14 days from the date the order was placed, the order will be cancelled.'| translate}}
                </span>
            </div>
            <div class="margin-10"
                *ngIf="((+orderFormGroup.controls['paymentSelector'].value === selectEnum.thirdOption) && money_Order_show && displayStatementForWavePayment) ||
                            ((+orderFormGroup.controls['paymentSelector'].value === +paymentTypeEnum.Orange_Money) && orange_money_show)">
                <span style="font-size: 14px;">
                    <span style="font-weight: bold">{{+orderFormGroup.controls['paymentSelector'].value ===
                        +paymentTypeEnum.Orange_Money ? ('checkout.Your Order will NOT be shipped until we
                        receive your Orange Money Payment.'| translate | translateKey) : 'checkout.Your Order will NOT be shipped
                        until we
                        receive your Wave Payment.'| translate | translateKey}}
                    </span>
                </span>

                <div class="row">
                    <form [formGroup]="paymentReferenceNumber">
                        <div class="col-md-6">
                            <label>Payment Reference Number:</label>
                        </div>
                        <div class="col-md-6">
                            <input type="text" for="refNumber" class="form-control" formControlName="referenceNumber" required
                                (change)="paymentReferenceNumberFormValidations()"
                                [attr.maxlength]="orderFormGroup.controls['paymentSelector'].value === paymentTypeEnum.Orange_Money?18:18">
                            <div *ngIf="paymentReferenceNumber?.get('referenceNumber').hasError('required') && paymentReferenceNumber.get('referenceNumber').touched || !paymentReferenceNumber.get('referenceNumber').hasError('pattern') && formInvalid && paymentReferenceNumber.get('referenceNumber').hasError('required')"
                                class="error">
                                <span>{{'Required' | translate}}</span>
                            </div>
                            <div *ngIf="paymentReferenceNumber?.get('referenceNumber').hasError('pattern')" class="error">
                                <span>{{'Please Enter Valid reference Number' | translate}}</span>
                            </div>
                            <div *ngIf="paymentReferenceNumber?.get('referenceNumber').hasError('maxlength')" class="error">
                                <span>{{'Maximum Length should be 18' | translate}}</span>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="margin-10"
                *ngIf="(+orderFormGroup.controls['paymentSelector'].value === +paymentTypeEnum.Cash_On_Delivery) && cash_on_delivery_show">
                <div class="information-block">
                    {{'checkout.Cash on Delivery Information' | translate |translateKey}}
                </div>
                <div class="col p-0 template3 border-outline">
                    <div class="px-4 py-3">
                        <h3 class="title">{{'checkout.Cash On Delivery' | translate |translateKey}}</h3>
                    </div>
                </div>
            </div>
            <div class="margin-10"
                *ngIf="(+orderFormGroup.controls['paymentSelector'].value === +paymentTypeEnum.BanContact_MisterCash_and_Maestro) && banContact_misterCash_and_maestro_show">
                <div class="information-block">
                    {{'checkout.BanContact MisterCash & Maestro Information' | translate |translateKey}}
                </div>
                <div class="col p-0 template3 border-outline">
                    <div class="px-4 py-3">
                        <h3 class="title">{{'checkout.BanContact MisterCash & Maestro' | translate |translateKey}}</h3>
                    </div>
                </div>
            </div>
            <div class="margin-10"
                *ngIf="(+orderFormGroup.controls['paymentSelector'].value === +paymentTypeEnum.MisterCash_and_Maestro) && misterCash_and_maestro_show">
                <div class="information-block">
                    {{'checkout.MisterCash & Maestro Information' | translate |translateKey}}
                </div>
                <div class="col p-0 template3 border-outline">
                    <div class="px-4 py-3">
                        <h3 class="title">{{'checkout.MisterCash & Maestro' | translate |translateKey}}</h3>
                    </div>
                </div>
            </div>
            <div class="margin-10"
                *ngIf="(+orderFormGroup.controls['paymentSelector'].value === +paymentTypeEnum.Bank_Transfer) && bank_transfer_show">
                <div class="information-block">
                    {{'checkout.Order will be processed once bank transfer received' | translate |translateKey}}
                </div>
                <div class="col p-0 template3 border-outline">
                    <div class="px-4 py-3">
                        <h3 class="title">{{'checkout.Bank Transfer Header' | translate |translateKey}}</h3>
                        <div class="slim-scroll bank-details-column" slimScroll width="100%" size="3px" height="inherit" alwaysVisible="true" wheelStep="20">
                            <span *ngIf="showCustomerBankTransferDetails" class="transfer-txt-style">{{'checkout.Bank Transfer Details' | translate|translateKey}}</span>
                            <div *ngIf="!showCustomerBankTransferDetails" class="pr-3">
                                <div class="bank-details-content" *ngFor="let details of bankDetailsCountryList">
                                    <div class="pl-0 w-100">
                                        <div class="row no-margin mb-10 bank-details-list">
                                            <div class="col-xs-8">
                                                <p *ngIf="details.bankName" ><span>{{'checkout.Bank Name' | translate |translateKey }}</span> : {{details.bankName}}</p>
                                                <p *ngIf="details.accountName"><span>{{'checkout.Account Name' | translate |translateKey }}</span> : {{details.accountName}}</p>
                                                <p *ngIf="details.iban"><span>{{'checkout.IBAN#' | translate |translateKey }}</span> : {{details.iban}}</p>
                                                <p *ngIf="details.accountNumber"><span>{{'checkout.Account Number' | translate |translateKey }}</span> : {{details.accountNumber}}</p>
                                                <p *ngIf="details.ifscCode"><span>{{'checkout.Swift Code' | translate |translateKey }}</span> : {{details.ifscCode}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="column-equal grayborder-1 flex-right-28-border hide"
            *ngIf="+orderFormGroup.controls['paymentSelector'].value !== selectEnum.thirdOption">
            <div class="row">
                <div class="col-md-12 text-right">
                    <span class="color-blue">{{'customer-service.PAY BY' |translate}}</span>
                </div>
            </div>
            <div *ngIf="orderFormGroup.controls['paymentSelector'].value == selectEnum.firstOption">
                <div class="row">
                    <div class="col-md-5">
                        <span>{{'order.Cardholder' |translate |translateKey}}</span>
                    </div>
                    <div class="col-md-7 text-right" *ngIf="selectedPayvisionCardInfo">
                        {{selectedPayvisionCardInfo?.nameOnTheCard}}
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-5">
                        <span>{{'order.Card Type' |translate |translateKey}}</span>
                    </div>
                    <div class="col-md-7 text-right" *ngIf="selectedPayvisionCardInfo">
                        <span class="cc-number"  [ngClass]="selectedPayvisionCardInfo?.cardType"></span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-5">
                        <span>{{'order.Card Number' |translate |translateKey}}</span>
                    </div>
                    <div class="col-md-7 text-right" *ngIf="selectedPayvisionCardInfo">
                        Ending in
                        {{selectedPayvisionCardInfo.maskedCard ? selectedPayvisionCardInfo.maskedCard.substr(selectedPayvisionCardInfo.maskedCard.length - 4) : ''}}
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-5">
                        <span>{{'order.Expiration' |translate |translateKey}}</span>
                    </div>
                    <div class="col-md-7 text-right" *ngIf="selectedPayvisionCardInfo">
                        <span
                            *ngIf="selectedPayvisionCardInfo?.expiryMonth?.length === 1">0</span>{{selectedPayvisionCardInfo?.expiryMonth}}/{{selectedPayvisionCardInfo?.expiryYear?.substring(2,4)}}
                    </div>
                </div>
            </div>
               <!-- Echeck Details -->
            <div *ngIf="orderFormGroup.controls['paymentSelector'].value == selectEnum.secondOption">
                <div class="row">
                    <div class="col-md-5">
                        <span>{{'order.Bank Name' |translate |translateKey}}</span>
                    </div>
                    <div class="col-md-7 text-right" *ngIf="echeckRequest">
                        {{echeckRequest?.bankName}}
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-5">
                        <span>{{'order.Accountholder' |translate |translateKey}}</span>
                    </div>
                    <div class="col-md-7 text-right" *ngIf="echeckRequest">
                        {{echeckRequest?.nameOnBankAccount}}
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-5">
                        <span>{{'order.Account Number' |translate |translateKey}}</span>
                    </div>
                    <div class="col-md-7 text-right" *ngIf="echeckRequest">
                        Ending with
                        {{echeckRequest?.accountNumber ? echeckRequest.accountNumber.substr(echeckRequest?.accountNumber.length - 4) : ''}}
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-5">
                        <span>{{'order.Email' |translate |translateKey}}</span>
                    </div>
                    <div class="col-md-7 text-right" *ngIf="echeckRequest">
                        {{echeckRequest?.email}}
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-5">
                        <span>{{'order.Phone Number' |translate |translateKey}}</span>
                    </div>
                    <div class="col-md-7 text-right" *ngIf="echeckRequest">
                        {{echeckRequest?.phone}}
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-5">
                        <span>{{'order.Account Type' |translate |translateKey}}</span>
                    </div>
                    <div class="col-md-7 text-right" *ngIf="echeckRequest">
                        {{echeckRequest?.accountType}}
                    </div>
                </div>
            </div>
             <!-- Ach Details -->
             <div  *ngIf="(+orderFormGroup.controls['paymentSelector'].value === +paymentTypeEnum.eCheck) && ach_show" >
                <div class="row">
                    <div class="col-md-5">
                        <span>{{'order.Bank Name' |translate |translateKey}}</span>
                    </div>
                    <div class="col-md-7 text-right" *ngIf="achRequest">
                        {{achRequest?.bankName}}
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-5">
                        <span>{{'order.Account Number' |translate |translateKey}}</span>
                    </div>
                    <div class="col-md-7 text-right" *ngIf="achRequest">
                        Ending with {{achRequest?.accountNumber ? achRequest.accountNumber.substr(achRequest?.accountNumber.length - 4) : ''}}
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-5">
                        <span>{{'order.Email' |translate |translateKey}}</span>
                    </div>
                    <div class="col-md-7 text-right" *ngIf="achRequest">
                        {{achRequest?.email}}
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-5">
                        <span>{{'order.Phone Number' |translate |translateKey}}</span>
                    </div>
                    <div class="col-md-7 text-right" *ngIf="achRequest">
                        {{achRequest?.phone}}
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-5">
                        <span>{{'order.Account Type' |translate |translateKey}}</span>
                    </div>
                    <div class="col-md-7 text-right" *ngIf="achRequest">
                        {{achRequest?.accountType}}
                    </div>
                </div>
            </div>
            <div *ngIf="orderFormGroup.controls['paymentSelector'].value == selectEnum.thirdOption">
                <div class="row">
                    <div class="col-md-5">
                        <span>{{'order.Payment Method' |translate |translateKey}}</span>
                    </div>
                    <div class="col-md-7 text-right">
                        {{'order.Money Order' |translate |translateKey}}
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Payment section ends-->
    <!-- Submit button section starts-->
    <div class="customFocus">
        <div class="col-md-12 text-right mb-20" *ngIf="isFBOEnrollmentEligible">
            <span *ngIf="paymentFormBtn && paymentFormBtn.disabled"
                class="fa fa-question-circle-o mr-2 place-order-error" containerClass="place-order--popover"
                triggers="mouseenter:mouseleave" [popover]="placeOrderDisabledTemplate"></span>
            <button role="button" type="button" class="btn blue-button" #paymentFormBtn
                [attr.disabled]="getSubmitButtonStatus()" (click)="submitEnrollment()">
                <span>{{'order.Submit' |translate |translateKey}}</span>
            </button>
            <button role="button" type="button" class="btn grey-button" (click)="clearOrderForm(true)">{{'checkout.Cancel'
                |translate |translateKey}}
            </button>
        </div>
    </div>
     <div class="mb-20 col-xs-12 no-padding" *ngIf="orderFormGroup.value.orderType === orderTypeFBO">
        <!-- Error Validations Starts -->
         <div class="col-md-12" *ngIf="fieldErrors&&fieldErrors.length>0">
                <div class="error" *ngFor="let validation of fieldErrors">
                    {{validation.message}}
                </div>
            </div>
        <!-- Error Validations Ends -->
    </div>
    <ng-template #placeOrderDisabledTemplate>
        {{'checkout.Please ensure that data in the mandatory fields are entered and the address is verified' |translate |translateKey}}
    </ng-template>
    <!-- Submit button section ends-->
</form>

<!-- popup for payment -->
<modal #paymentModal class="">
    <modal-header>
    </modal-header>
    <modal-content>
        <!-- Payvision form starts -->
        <div class="p-0">
            <div id="pvscript"> </div>
        </div>
        <!-- Payvision form Ends -->
    </modal-content>
    <modal-footer>
    </modal-footer>
</modal>
<modal [closeOnEscape]="false" [closeOnOutsideClick]="false" #payvisionPayment (onClose)="onPayvisionFormClose()">
    <modal-header>
        <span class="pull-right pointer" *ngIf="paymentComponentSettings && paymentComponentSettings.payvisionFormLoaded" (click)="onPayvisionFormClose()">X</span>
    </modal-header>
    <modal-content>
        <!-- Payvision form starts -->
        <payment-payvision *ngIf="addNewPayvisionCard" [paymentComponentSettings]="paymentComponentSettings"></payment-payvision>
        <!-- Payvision form Ends -->
    </modal-content>
    <modal-footer>
    </modal-footer>
</modal>
<modal #eCheckPaymentPopup (onClose)="onECheckFormClose()" class="echeck-modal">
    <modal-header>
        <div class="color-blue">{{'order.ECHECK PAYMENT' |translate}}</div>
    </modal-header>
    <modal-content>
        <!-- eCheck form starts -->
        <div *ngFor="let message of eCheckValidationMessages">
            <li class="alert-msg pad-bot-8">
                {{message}}
            </li>
        </div>
        <div *ngIf="addNeweCheck">
            <form [formGroup]="echeckForm" (ngSubmit)="validateNewECheck()">
                <div class="row">
                    <div class="col-md-6 floating-input floatLabelContainer">
                        <input #routerNumberInput id="routerNumberInput" float-label type="text" formControlName="routerNumber" class="form-control" placeholder="Routing Number*" />
                        <div class="alert-msg" *ngIf="!echeckForm.controls['routerNumber'].valid && echeckForm.controls['routerNumber'].hasError('required') && (echeckForm.controls['routerNumber'].touched || echeckSubmitted)">
                            {{'order.Required' |translate}}
                        </div>
                        <div class="alert-msg" *ngIf="!echeckForm.controls['routerNumber'].valid && echeckForm.controls['routerNumber'].hasError('alphaNumericValidation') && (echeckForm.controls['routerNumber'].touched || echeckSubmitted)">
                            {{'order.Invalid Routing Number' |translate}}
                        </div>
                        <div class="alert-msg" *ngIf="!echeckForm.controls['routerNumber'].valid && echeckForm.controls['routerNumber'].hasError('maxlength') && !echeckForm.controls['routerNumber'].hasError('alphaNumericValidation') && (echeckForm.controls['routerNumber'].touched || echeckSubmitted)">
                            {{'order.Length cannot be greater than 9' |translate}}
                        </div>
                    </div>
                    <div class="col-md-6  floating-input floatLabelContainer">
                        <input float-label type="text" formControlName="accountNumber" class="form-control" placeholder="Account Number*" />
                        <div class="alert-msg" *ngIf="!echeckForm.controls['accountNumber'].valid && echeckForm.controls['accountNumber'].hasError('required') && (echeckForm.controls['accountNumber'].touched || echeckSubmitted)">
                            {{'order.Required' |translate}}
                        </div>
                    </div>
                    <div class="col-md-6  floating-input">
                        <select tabindex="0" attr.aria-label="{{'echeck.Select Account Type' | translate | translateKey}}" attr.data-placeholder="{{'echeck.Select Account Type' | translate | translateKey}}*" role="listbox" class="form-control" formControlName="accountType">
                            <option role="option" disabled>{{'echeck.Select Account Type' | translate | translateKey}}*</option>
                            <option role="option" *ngFor="let accounttype of accountTypes" [value]="accounttype">{{accounttype
                                | titlecase}}</option>
                        </select>
                        <div class="alert-msg" *ngIf="!echeckForm.controls['accountType'].valid && echeckForm.controls['accountType'].hasError('required') && (echeckForm.controls['accountType'].touched || echeckSubmitted)">
                            {{'order.Required' |translate}}
                        </div>
                    </div>
                    <div class="col-md-6 floating-input floatLabelContainer">
                        <input float-label type="text" formControlName="nameOnBankAccount" class="form-control" placeholder="Name on bank Account*" />
                        <div class="alert-msg" *ngIf="!echeckForm.controls['nameOnBankAccount'].valid && echeckForm.controls['nameOnBankAccount'].hasError('required') && (echeckForm.controls['nameOnBankAccount'].touched || echeckSubmitted)">
                            {{'order.Required' |translate}}
                        </div>
                        <div class="alert-msg" *ngIf="!echeckForm.controls['nameOnBankAccount'].valid && echeckForm.controls['nameOnBankAccount'].hasError('alphaNumericValidation') && (echeckForm.controls['nameOnBankAccount'].touched || echeckSubmitted)">
                            {{'order.Only Alphanumeric characters are allowed' |translate}}
                        </div>
                        <div class="alert-msg" *ngIf="!echeckForm.controls['nameOnBankAccount'].valid && echeckForm.controls['nameOnBankAccount'].hasError('maxlength') && !echeckForm.controls['nameOnBankAccount'].hasError('alphaNumericValidation') && (echeckForm.controls['nameOnBankAccount'].touched || echeckSubmitted)">
                            {{'order.Length cannot be greater than 25' |translate}}
                        </div>
                    </div>
                    <div class="col-md-6 floating-input floatLabelContainer">
                        <input float-label type="text" formControlName="bankName" class="form-control" placeholder="Bank Name*" />
                        <div class="alert-msg" *ngIf="!echeckForm.controls['bankName'].valid && echeckForm.controls['bankName'].hasError('required') && (echeckForm.controls['bankName'].touched || echeckSubmitted)">
                            {{'order.Required' |translate}}
                        </div>
                    </div>
                    <div class="col-md-6 floating-input floatLabelContainer">
                        <input float-label type="text" formControlName="email" class="form-control" placeholder="Email*"  pattern="^[a-zA-Z0-9_+-]+(\.[a-zA-Z0-9_+-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$" [maxlength]="50" required/>
                        <div class="alert-msg" *ngIf="!echeckForm.controls['email'].valid && echeckForm.controls['email'].hasError('required') && (echeckForm.controls['email'].touched || echeckSubmitted)">
                            {{'order.Required' |translate}}
                        </div>
                        <div class="alert-msg" *ngIf="!echeckForm.controls['email'].valid && echeckForm.controls['email'].hasError('pattern') && (echeckForm.controls['email'].touched || echeckSubmitted)">
                            {{'checkout.Please enter a valid email address' | translate | translateKey}}
                        </div>
                    </div>
                    <div class="col-md-6 floating-input floatLabelContainer">
                        <input float-label type="text" formControlName="phone" [maxlength]="15" class="form-control" placeholder="Phone Number*" (input)="onChangeEcheckPhone($event)" />
                        <div class="alert-msg" *ngIf="!echeckForm.controls['phone'].valid && echeckForm.controls['phone'].hasError('required') && (echeckForm.controls['phone'].touched || echeckSubmitted)">
                            {{'order.Required' |translate}}
                        </div>
                        <div class="alert-msg" *ngIf="!echeckForm.controls['phone'].valid && echeckForm.controls['phone'].hasError('InvalidPhoneNo') && (echeckForm.controls['phone'].touched || echeckSubmitted)">
                            {{'order.Please enter valid Phone Number' | translate | translateKey}}
                        </div>
                    </div>
                    <div class="col-md-12">
                        <span aria-label="billing address" class="pl-0 card-color address-label helvetica-bold"><b>{{'echeck.Billing
                                Address'|translate}}
                            </b></span>
                    </div>
                    <div class="col-md-12">
                        <div class="pt-5">
                            <app-address-new class="shipping-address-schema" (addressSubmit)="saveBillingAddress($event)" [schemaUrl]="billingSchemaUrl" [countryCode]="countryCode" [onCountryChange]="true" [skipAddressVerification]="true"></app-address-new>
                        </div>
                    </div>
                    <div class="col-md-12 text-right hide">
                        <button #saveEcheckFormBtn tabindex="0" class="btn blue-button" type="submit">
                            {{'config-system.Submit' |translate |translateKey}}
                        </button>
                        <button tabindex="0" class="btn grey-button" type="button" (click)="onECheckFormClose()" data-dismiss="modal" aria-label="Close">
                            {{'config-system.cancel' |translate |translateKey}}
                        </button>
                    </div>
                    <div class="col-xs-12">
                        <input type="checkbox" formControlName="reuse" class="" /><span>{{'config-system.Save for
                            future use' |translate |translateKey}}</span>
                        <span title="{{'payment.Save for future use'|translate| translateKey}}" class="ico-help fa fa-question-circle-o font-size-18"></span>
                    </div>
                </div>
            </form>
        </div>
        <!-- eCheck form Ends -->
    </modal-content>
    <modal-footer>
    </modal-footer>
</modal>
<modal [closeOnEscape]="false" [closeOnOutsideClick]="false" #showWorldPayXMLPopup (onClose)="onWorldpayXMLFormClose()">
    <modal-header>
        <span class="pull-right pointer" (click)="onWorldpayXMLFormClose()">X</span>
    </modal-header>
    <modal-content>
        <!-- Worldpay XML form starts -->
        <payment-worldpay-xml *ngIf="showWorldpayXml" [paymentComponentSettings]="paymentComponentSettings" [setPickupAddress]="setPickupAddress" [deliveryPreferenceType]="deliveryPreferenceType"></payment-worldpay-xml>
        <!-- Worldpay XML form Ends -->
    </modal-content>
    <modal-footer>
    </modal-footer>
</modal>
<modal
   
    [closeOnEscape]="false" [closeOnOutsideClick]="false" #showAdyenPaymentPopup (onClose)="onAdyenPaymentFormClose()">
    <modal-header>
        <span class="pull-right pointer" (click)="onAdyenPaymentFormClose()">X</span>
    </modal-header>
    <modal-content>
        <!-- Adyen Payment form starts -->
        <app-adyen-payment *ngIf="showAdyenPayment" [adyenPaymentComponentSettings]="paymentComponentSettings" [orderType]="orderTypeFBO" [sessionGuid]="sessionGuid">
        </app-adyen-payment>
        <!-- Adyen Payment form Ends -->
    </modal-content>
    <modal-footer>
    </modal-footer>
</modal>
<modal [closeOnEscape]="false" [closeOnOutsideClick]="false" #showNIPopup (onClose)="onNIFormClose()">
    <modal-header>
        <span class="pull-right pointer" (click)="onNIFormClose()">X</span>
    </modal-header>
    <modal-content>
        <!-- NI form starts -->
        <payment-network-international *ngIf="showNIPayment" [paymentComponentSettings]="paymentComponentSettings"></payment-network-international>
        <!-- NI form Ends -->
    </modal-content>
    <modal-footer>
    </modal-footer>
</modal>
<modal [closeOnEscape]="false" [closeOnOutsideClick]="false" #showNexioPopup (onClose)="onNexioFormClose()">
    <modal-header>
        <span class="pull-right pointer" (click)="onNexioFormClose()">X</span>
    </modal-header>
    <modal-content>
        <!-- Nexio form starts -->
        <app-nexio *ngIf="showNexioPayment" [paymentComponentSettings]="paymentComponentSettings" (savedcardSubmit)="savedCardInfo($event)" [products]="products"></app-nexio>
        <!-- Nexio form Ends -->
    </modal-content>
    <modal-footer>
    </modal-footer>
</modal>
<modal #showRestrictedProducts (onOpen)="restrictionPopupOpen(true)" (onClose)="restrictionPopupOpen(false)">
    <modal-header>
        <div class="color-blue">{{'order.SHIPPING RESTRICTIONS' |translate |translateKey}}</div>
    </modal-header>
    <modal-content>
        <div *ngIf="orderFormGroup.value.deliveryPreference !== deliveryPreference.PICKUP" class="red-color top-minus-10">
            {{productErrorMsg |translateKey}}
        </div>
        <div *ngIf="orderFormGroup.value.deliveryPreference === deliveryPreference.PICKUP" class="red-color top-minus-10">{{'order.Following products are not allowed for selected Pickup address' |translate |translateKey}}
        </div>
        <div class="mb-5" *ngFor="let productName of restrictedProducts">
            <span>{{productName}}</span>
        </div>
        <div class="text-right mt-20"><button role="button" type="button" class="btn grey-button" (click)="showRestrictedProducts.close();">{{'checkout.Close'|translate |translateKey}}
            </button></div>
    </modal-content>
    <modal-footer>
    </modal-footer>
</modal>
<!-- modal for ach payment -->
<modal #achPaymentPopup  [closeOnEscape]="false" [closeOnOutsideClick]="false" (onClose)="onPaymentAchFormClose()" class="ach-modal" *ngIf="ach_show">
    <modal-header>
        <div class="color-blue">{{'order.Ach Payment Form' |translate}}</div>
         <span class="pull-right pointer" (click)="onPaymentAchFormClose()">X</span>
   </modal-header>
   <modal-content *ngIf="paymentComponentSettings">
          <app-payment-echeck  [paymentComponentSettings]="paymentComponentSettings"
           (submitAchPayment)="submitAchPaymentInformation($event)"></app-payment-echeck>
   </modal-content>
 <modal-footer>
 </modal-footer>
</modal>
<ng-template #notAvailable>{{'order.NA' |translate |translateKey}}</ng-template>
<!-- STOCK AVAILABILITY CHECK START -->
<modal [closeOnEscape]="false" [closeOnOutsideClick]="false" #outOfStockModal>
    <modal-header>
        <div class="color-blue text-uppercase">{{'order.Out of stock' |translate |translateKey}}</div>
    </modal-header>
    <modal-content>
     <div class="red-color top-minus-10">
            <ng-container *ngIf="orderFormGroup.value.deliveryPreference===deliveryPreference.PICKUP">
                {{'This item(s) cannot be picked up from the selected location, remove item(s) from cart'}}
            </ng-container>
            <ng-container *ngIf="orderFormGroup.value.deliveryPreference===deliveryPreference.DELIVERY">
                {{'This item(s) cannot be shipped to your shipping address, remove item(s) from cart'}}
            </ng-container>
      </div>
      <div class="mb-5" *ngFor="let item of outOfStockItems;">
          <span>{{item.displayName}} - #{{item.itemNumber}} - </span><span class="text-red">{{'available quantity'}} - {{item.stockQuantity}}</span>
      </div>
        <div class="text-right mt-20">
          <button role="button" type="button" class="btn blue-button" (click)="clearOutOfStockItems()">
            {{'order.ok'|translate |translateKey}}
          </button>
          <button tabindex="0" class="btn grey-button" type="button" (click)="closeOutOfStockForm()" data-dismiss="modal" aria-label="Close">
            {{'config-system.cancel' |translate |translateKey}}
          </button>
        </div>
      </modal-content>
    <modal-footer>
    </modal-footer>
</modal>
<!-- STOCK AVAILABILITY CHECK END -->
<!-- CHANGE PARTICIAPTING COUNTRY WARNING-->
<modal [closeOnEscape]="false" [closeOnOutsideClick]="false" #participatingCountryChangeConfirmation>
    <modal-header>
        <h4>{{'config-system.Are You Sure?' | translate  |  translateKey}}</h4>
    </modal-header>
    <modal-content>
        <p> {{'config-system.Changing Participating Country will clear all the entered Information' | translate  |  translateKey}} </p>
    </modal-content>
    <modal-footer>
        <button class="btn btn-primary"
            (click)="selectParticipatingCountry();participatingCountryChangeConfirmation.close();">{{'config-system.Yes' | translate  |  translateKey}}</button>
        <button class="btn btn-danger cancel"
            (click)="closePopUp();">{{'config-system.No' | translate  |  translateKey}}</button>
    </modal-footer>
</modal>
<modal  [closeOnEscape]="false" [closeOnOutsideClick]="false" #overrideMinimumLimit >
    
    <modal-header>
        <div class="color-blue">{{'order.CHANGE OVERRIDE MINIMUM LIMIT' |translate |translateKey}}  <span class="pull-right pointer"  (click)="closeOverrideMinimumLimit()">X</span></div> 
    </modal-header>
    <modal-content>
    <div class="row">
        <div class="col-md-10 mb-10 p-5">
            <h4 style="font-size: 19px;" class="bold">{{'order.To override the minimum limit, please select the box below' |translate |translateKey}}:</h4>
            <div>
                <input type="checkbox" [(ngModel)]="isOverrideMinimumLimit" (change)="overrideMinimumLimitValueCheck($event)" />&nbsp;<span style="font-size: 14px;"  >{{'order.Override order minimum' |translate |translateKey}}</span>
            </div>
        </div>
    </div>   
    <div class="clearboth pull-right pad-r-8">
        <button class="btn blue-button" tabindex="0" type="button"  (click)="closeNotification()">
            {{'order.OK' |translate |translateKey}}
        </button>
        <button class="btn grey-button" tabindex="0" type="button" (click)="closeOverrideMinimumLimit()">
            {{'config-system.CANCEL' |translate |translateKey}}
        </button>
    </div>
    </modal-content>
    <modal-footer>
    </modal-footer>
</modal>
<!-- CHANGE PARTICIAPTING COUNTRY WARNING END-->



// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/order-promotion-fbo.component.html